import { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { API, Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import './Level4.scss';
import StorePage from '../Store/Store'
import { getVideo, GetUserVideo } from '../../s3Func/s3Download';
import Coin from '../Coin/Coin'
import Celebrate from '../Celebrate/Celebrate';
import Game from '../PressYourLuck/Game'
import Animal from '../Animal/Animal'
import Store from '../Store/store.jpg'
import Intro from '../Conversation/Intro';
import Build from '../Conversation/Build'
import Conversation from '../Conversation/Conversation'
import Valuation from '../Conversation/Valuation'
import Share from '../Conversation/Share'
import Surprise from '../SurpriseVideo/surprise';
import ChatChallenge from '../ChatChallenge/ChatChallenge';
import ChatChallengeChampion from '../ChatChallenge/ChatChallengeChampion';
import { getChatChallengeFlow } from '../ChatChallenge/chatChallengeFlows';
import Draggable from 'react-draggable';
import presentSound from "./../../Unit1/Module1/assets/ta_da_gift.mp3"

const Level4 = (props) => {
    const { login } = useSelector((state) => state.loginReducer, shallowEqual);
    const { freeplay } = useSelector((state) => state.freeplay, shallowEqual);
    const firstUpdate = useRef(true);
    const dispatch = useDispatch();
    const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;


    const [clientHeight, setVh] = useState(window.innerHeight);
    const [clientWidth, setVw] = useState(window.innerWidth);

    useEffect(() => {
      const handleResize = () => {
        setVh(window.innerHeight);
        setVw(window.innerWidth);
      };
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, [clientHeight, clientWidth]);

    function sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    const navigate = useNavigate();
    const [displayDecorate, setDisplayDecorate] = useState(props.decorate || props.store);
    const [displayStep0, setDisplayStep0] = useState(!props.decorate && !props.store);
    const [displayStep1, setDisplayStep1] = useState(false);
    const [displayStep2, setDisplayStep2] = useState(false);
    const [displayStep3, setDisplayStep3] = useState(false);
    const [displayStep4, setDisplayStep4] = useState(false);
    const [displayStore, setDisplayStore] = useState(props.store);
    const [displayStoreCharacter, setDisplayStoreCharacter] = useState(false);
    const [storeReady, setStoreReady] = useState(false);
    const [studentName, setStudentName] = useState('');
    const [friendName, setFriendName] = useState('');
    const [valuationQuestions, setValuationQuestions] = useState(null);

    const [selectedStudentCharacter, setSelectedStudentCharacter] = useState(null)
    const [selectedFriendCharacter, setSelectedFriendCharacter] = useState(null)
    const [celebrateText, setCelebrateText] = useState('');
    const [celebrateVoice, setCelebrateVoice] = useState('');
    const [displaySurpriseVideoIcon, setDisplaySurpriseVideoIcon] = useState(false);
    const [displaySurpriseVideo, setDisplaySurpriseVideo] = useState(false);
    const [surpriseVideo, setSurpriseVideo] = useState("");
    const [prize, setPrize] = useState(false);

    const [displayCoin, setDisplayCoin] = useState(false);
    const [displayValuation, setDisplayValuation] = useState(false);
    const [displayCelebrate, setDisplayCelebrate] = useState(false);
    const [displayCoinAfterConversation, setDisplayCoinAfterConversation] = useState(false);
    const [displayCoinAfterValuation, setDisplayCoinAfterValuation] = useState(false);
    const [displayCoinAfterCelebrate, setDisplayCoinAfterCelebrate] = useState(false);
    const [displayGame, setDisplayGame] = useState(false);
    const [displayShare, setDisplayShare] = useState(false);
    const [displayAnimal, setDisplayAnimal] = useState(false);
    const [animal, setAnimal] = useState('');
    const [animals, setAnimals] = useState([]);
    const [topicName, setTopicName] = useState('');
    const [change, setChange] = useState(false);
    const [practice, setPractice] = useState(false);
    const [afterConversation, setAfterConversation] = useState(false);
    const [topics, setTopics] = useState(null);
    const [conversationNum, setConversationNum] = useState(-1);
    const [conversationName, setConversationName] = useState('');
    const [displayChatChallenge, setDisplayChatChallenge] = useState(false);
    const [chatChallengeFlow, setChatChallengeFlow] = useState(null);
    const [chatChallengeTopicName, setChatChallengeTopicName] = useState('');
    const [displayChatChampion, setDisplayChatChampion] = useState(false);
    const [championAnimalImage, setChampionAnimalImage] = useState('');
    const influencers = [login.influencerid, login.influencerid1,login.influencerid2,login.influencerid3,login.influencerid4,login.influencerid, login.influencerid1,login.influencerid2,login.influencerid3,login.influencerid4]
    const giftBtn = generateImageUrl('images/Images/Gift.png', login);
    const playIcon = generateImageUrl('images/newDesign/FreePlay/play.png')
    const lockIcon = generateImageUrl('images/newDesign/FreePlay/lock.png')
    const rewardSound = new Audio(presentSound);
    const conversationNames = ['favorite', 'feeling', 'listening', 'friends', 'solution', 'conflict', 'advocacy', 'community']

    const updateFreeplay = (async () => {
		const payload = {
			body: {
				id: login.studentid,
				name: "level4",
				coin: freeplay.level4Coin,
				progress: JSON.stringify(freeplay.level4),
                decorate: JSON.stringify(freeplay.level4Decorate)
			},
		}
		await API.put('TIR', '/v3/student/freeplay', payload)
		.then((response) => {
		})
		.catch((error) => {
		});
        const myInit2 = {
            body: {
              id: login.studentid,
              current_module: 'Level4',
            },
          };
          await API.put('TIR', '/v3/student', myInit2)
          .then((response) => {
          })
          .catch((error) => {
          });
	})

    const getNestedLength = (obj) => {
        let length = 0;
        Object.values(obj).forEach(value => {
            Object.values(value).forEach(module => {
                if (module.unlocked === 1) {
                    length += 1
                }
            });
        });
        return length;
    };
    
    const updateProgress = (async () => {
        const totalLength = getNestedLength(freeplay.level4);
		const payload = {
			body: {
				id: login.studentid,
				module: `Level4`,
				day_completed: totalLength,
				time_completed: new Date().toDateString(),
			},
		}
		await API.put('TIR', '/v3/student/progress', payload)
		.then((response) => {
		})
		.catch((error) => {
		});
	})

    const getAnimalData = async (levelName, unlockedCount, animalName) => {
        if (Object.values(freeplay.level4[levelName]).filter(value => value.unlocked === 1).length === unlockedCount) {
            let photo;
            await GetUserVideo(`userfiles/${login.studentid}/level4_${levelName}_animal.png`).then((data) => {
                photo = data
            });
            await fetch(photo).then((response) => {
                if (response.status === 200) {
                    let item = {
                        img: photo,
                        name: levelName,
                        animal: animalName,
                        coin: 0
                    };

                    // Update the boughts array
                    boughts.forEach(existingItem => {
                        if (existingItem.name === levelName) {
                            existingItem.url = photo;
                        }
                    });

                    // Update or add item in the animals array
                    const foundItem = animals.find(existingItem => existingItem.name === levelName);
                    if (foundItem) {
                        foundItem.img = photo;
                    } else {
                        animals.push(item);
                    }

                    // Update the state
                    setBoughts(boughts);
                    setAnimals(animals);
                }
            });
        }
    };
    
    const getAnimals = async () => {
        const animalConfigurations = [
            { levelName: "favorite", unlockedCount: 5, animalName: "fish" },
            { levelName: "feeling", unlockedCount: 6, animalName: "octopus"},
            { levelName: "listening", unlockedCount: 6, animalName: "frog"},
            { levelName: "friends", unlockedCount: 5, animalName: "gnome"},
            { levelName: "solution", unlockedCount: 3, animalName: "owl"},
            { levelName: "conflict", unlockedCount: 5, animalName: "dinosaur"},
            { levelName: "advocacy", unlockedCount: 5, animalName: "sasquatch"},
            { levelName: "community", unlockedCount: 10, animalName: "alien"}
        ];
    
        // Iterate over each animal configuration and call the function
        for (const config of animalConfigurations) {
            try{
                await getAnimalData(config.levelName, config.unlockedCount, config.animalName);
            }
            catch(error){}
        }
        setStoreReady(true);
    };
    
    useEffect(() => {
        const fetchData = async () => {
            let modules = ['favorite', 'feeling', 'listening', 'friends', 'solution', 'conflict', 'advocacy', 'community'];
            
            // Loop through boughts and fetch data if necessary
            for (let item of boughts) {
                if (modules.includes(item.name)) {
                    try {
                        // Await the fetch to check the URL status
                        const response = await fetch(item.url);

                        // If the response is not OK (status !== 200), fetch the new image
                        if (response.status !== 200) {
                            const data = await GetUserVideo(`userfiles/${login.studentid}/level4_${item.name}_animal.png`);
                            item.url = data; // Directly update the URL property
                        }
                    } catch (error) {
                        // In case of an error, attempt to get the video
                        const data = await GetUserVideo(`userfiles/${login.studentid}/level4_${item.name}_animal.png`);
                        item.url = data; // Directly update the URL property
                    }
                }
            }
            
            // After processing all items, update the state with a new reference
            setBoughts([...boughts]); // Trigger re-render with updated state
        };
    
        fetchData();
    }, []);

    useEffect(() => {
        if(displayStore){
            getAnimals();
        }
    }, [displayStore]);
    

    const backgrounds = [generateImageUrl('images/Module6Images/Day+Scene+Nav+Template+-+ML+%E2%80%93+2.png'), 
                         generateImageUrl('images/Module7Images/Day+Scene+Nav+Template+-+ML+%E2%80%93+3.png'),
                         generateImageUrl('images/Module8Images/Module8NavImages/Background_JourneyMap_Unit2_Mod3.png'),
                         generateImageUrl('images/Module9Images/m9-BG-chromebook.png'),
                         generateImageUrl('images/Module10Images/Unit2_Mod5BGupdated.png')]
    const [bgIdx, setBgIdx] = useState(freeplay.level4Decorate.background);

    const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png')
    const greenCheckSound = new Audio(generateImageUrl('media/Module1Videos/button_accept_item.mp3'))
    const Exit = generateImageUrl('images/Images/close.png')
    const coin = generateImageUrl('images/Images/Coin_Empty.png');


    let buys = [
        { img: 'images/Module6Images/DailyReward_YellowFishes.png', name: "FishSchoolYellow", coin: 4 },
        { img: 'images/Module6Images/DailyReward_GreenFishes.png', name: "FishSchoolGreen", coin: 4 },
        { img: 'images/Module6Images/DailyReward_Dolphin.png', name: "Dolphin", coin: 6 },
        { img: 'images/Module6Images/DailyReward_Shark.png', name: "Shark", coin: 8 },
        { img: 'images/Module6Images/DailyReward_SeaweedGreen@3x.png', name: "SeaweedGreen", coin: 4 },
        { img: 'images/Module6Images/DailyReward_SeaweedBrown@3x.png', name: "SeaweedBrown", coin: 4 },
        { img: 'images/Module6Images/DailyReward_BluePearl.png', name: "ClamBlue", coin: 4 },
        { img: 'images/Module6Images/DailyReward_PinkPearl.png', name: "ClamPink", coin: 4 },
        { img: 'images/Module6Images/DailyReward_CoralRed.png', name: "CoralRed", coin: 4 },
        { img: 'images/Module6Images/DailyReward_CoralBlue.png', name: "CoralBlue", coin: 4 },
        { img: 'images/Module6Images/DailyReward_ShipGreen.png', name: "SunkenShipGreen", coin: 8 },
        { img: 'images/Module6Images/DailyReward_ShipBrown.png', name: "SunkenShip", coin: 8 },
        { img: 'images/Module6Images/DailyReward_CoralGreen.png', name: "CoralGreen", coin: 4 },
        { img: 'images/Module6Images/DailyReward_CoralPurple.png', name: "CoralPurple", coin: 4 },
        { img: 'images/Module6Images/DailyReward_Mermaid1.png', name: "MermaidBlue", coin: 6 },
        { img: 'images/Module6Images/DailyReward_Mermaid2.png', name: "MermaidRed", coin: 6 },
        { img: 'images/newDesign/FreePlay/rewards/BigReward_InsideCir_Castle.png', name: "SandCastle", coin: 10 },
        { img: 'images/Module6Images/BigReward_Treasure.svg', name: "Treasure", coin: 12 },
        { img: 'images/Module7Images/DailyReward_Gnome1.png', name: "GnomeBlue", coin: 6 },
        { img: 'images/Module7Images/DailyReward_Crystal_Blue.png', name: "CrystalBlue", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Flower_Pink.png', name: "FlowerPink", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Flower_Blue.png', name: "FlowerBlue", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Fairy1.png', name: "FairyPurple", coin: 6 },
        { img: 'images/Module7Images/DailyReward_Crystal_Pink.png', name: "CrystalPurple", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Fireflies_Pink.png', name: "FireflyPink", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Frog_Crown2.png', name: "CrownRound", coin: 6 },
        { img: 'images/Module7Images/DailyReward_Fairy2.png', name: "FairyGreen", coin: 6 },
        { img: 'images/Module7Images/DailyReward_Fireflies_Orange.png', name: "FireflyOrange", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Mushrooms_Blue.png', name: "MushroomBlue", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Mushrooms_Purple.png', name: "MushroomPurple", coin: 4 },
        { img: 'images/Module7Images/DailyReward_MossyRock.png', name: "Rock", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Log2.png', name: "Log", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Gnome2.png', name: "GnomeGreen", coin: 6 },
        { img: 'images/Module7Images/DailyReward_Frog_Crown1.png', name: "CrownSpike", coin: 6 },
        { img: 'images/Module7Images/BigReward_Fae_Dragon.png', name: "FaeDragon", coin: 12 },
        { img: 'images/Module7Images/BigReward_Fae_House.png', name: "FaeHouse", coin: 10 },
        { img: 'images/Module8Images/DailyReward_Tree_2.png', name: "Tree2", coin: 8 },
        { img: 'images/Module8Images/DailyReward_Stego_Blue.png', name: "StegoBlue", coin: 6 },
        { img: 'images/Module8Images/DailyReward_DinoLongNeck_Green.png', name: "LongNeckGreen", coin: 8 },
        { img: 'images/Module8Images/DailyReward_DinoLongNeck_Red.png', name: "LongNeckRed", coin: 8 },
        { img: 'images/Module8Images/DailyReward_Raptor_LightBlue.png', name: "RaptorLight", coin: 6 },
        { img: 'images/Module8Images/DailyReward_Stego_Green.png', name: "StegoGreen", coin: 6 },
        { img: 'images/Module8Images/DailyReward_DinoEggs_green.png', name: "EggsGreen", coin: 6 },
        { img: 'images/Module8Images/DailyReward_DinoFlying_Green.png', name: "DinoFlyingGreen", coin: 8 },
        { img: 'images/Module8Images/DailyReward_Raptor_Darker.png', name: "RaptorDark", coin: 8 },
        { img: 'images/Module8Images/DailyReward_DinoEggs_blue.png', name: "EggsBlue", coin: 6 },
        { img: 'images/Module8Images/DailyReward_Dino_Orange.png', name: "DinoOrange", coin: 6 },
        { img: 'images/Module8Images/DailyReward_Dino_Green.png', name: "DinoGreen", coin: 6 },
        { img: 'images/Module8Images/DailyReward_Plant1.png', name: "Plant1", coin: 4 },
        { img: 'images/Module8Images/DailyReward_Plant2.png', name: "Plant2", coin: 4 },
        { img: 'images/Module8Images/DailyReward_Tree_1.png', name: "Tree1", coin: 8 },
        { img: 'images/Module8Images/DailyReward_DinoFlying_Purple.png', name: "DinoFlyingPurple", coin: 8 },
        { img: 'images/newDesign/Unit2Module8/BigRewardVolcanoNoSmoke.png', name: "Volcano", coin: 10 },
        { img: 'images/Module8Images/BigReward_TRex@2x.png', name: "TRex", coin: 12 },
        { img: 'images/Module9Images/DailyReward_Waterfall2@3x.png', name: "Waterfall2", coin: 8 },
        { img: 'images/Module9Images/DailyReward_Horse2.png', name: "Horse2", coin: 6 },
        { img: 'images/Module9Images/DailyReward_Sytar1.png', name: "Sytar1", coin: 10 },
        { img: 'images/Module9Images/DailyReward_Sytar2.png', name: "Sytar2", coin: 10 },
        { img: 'images/Module9Images/DailyReward_Hat1.png', name: "Hat1", coin: 8 },
        { img: 'images/Module9Images/DailyReward_Horse1.png', name: "Horse1", coin: 6 },
        { img: 'images/Module9Images/DailyReward_Owl2.png', name: "Owl2", coin: 4 },
        { img: 'images/Module9Images/DailyReward_Pheonix.png', name: "Pheonix", coin: 8 },
        { img: 'images/Module9Images/DailyReward_Hat2.png', name: "Hat2", coin: 8 },
        { img: 'images/Module9Images/DailyReward_Owl1.png', name: "Owl1", coin: 4 },
        { img: 'images/Module9Images/DailyReward_Yeti_Brown.png', name: "YetiBrown", coin: 6 },
        { img: 'images/Module9Images/DailyReward_Yeti.png', name: "Yeti", coin: 6 },
        { img: 'images/Module9Images/DailyReward_Bluejay.png', name: "Bluejay", coin: 4 },
        { img: 'images/Module9Images/DailyReward_Woodpecker.png', name: "Woodpecker", coin: 4 },
        { img: 'images/Module9Images/DailyReward_Waterfall1@3x.png', name: "Waterfall1", coin: 8 },
        { img: 'images/Module9Images/DailyReward_Dragon.png', name: "Dragon", coin: 8 },
        { img: 'images/Module9Images/BigReward_Castle.png', name: "MedievalCastle", coin: 12 },
        { img: 'images/Module10Images/DailyReward_CometOrange.png', name: "CometOrange", coin: 8 },
        { img: 'images/Module10Images/DailyReward_Alien2.png', name: "Alien2", coin: 6 },
        { img: 'images/Module10Images/DailyReward_Planet1.png', name: "Planet1", coin: 8 },
        { img: 'images/Module10Images/DailyReward_Planet2.png', name: "Planet2", coin: 8 },
        { img: 'images/Module10Images/DailyReward_SpaceHelment1.png', name: "Helmet1", coin: 8 },
        { img: 'images/Module10Images/DailyReward_Alien1.png', name: "Alien1", coin: 6 },
        { img: 'images/Module10Images/DailyReward_SpaceHelment2.png', name: "Helmet2", coin: 8 },
        { img: 'images/Module10Images/DailyReward_UFO2.png', name: "UFO2", coin: 8 },
        { img: 'images/Module10Images/DailyReward_UFO1.png', name: "UFO1", coin: 8 },
        { img: 'images/Module10Images/DailyReward_Rocket1.png', name: "Rocket1", coin: 8 },
        { img: 'images/Module10Images/DailyReward_Rocket2.png', name: "Rocket2", coin: 8 },
        { img: 'images/Module10Images/DailyReward_CometBlue.png', name: "CometBlue", coin: 8 },
        { img: 'images/Module10Images/BigReward_Galaxy.png', name: "Galaxy", coin: 12 },
      ];
      
      
    buys = buys.sort((a, b) => a.coin - b.coin);

    const [boughts, setBoughts] = useState(freeplay.level4Decorate.items);

    const [update, setUpdate] = useState(false);


    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
        } else {
            updateFreeplay();
        }
    }, [freeplay.level4Coin, freeplay.level4, update]);

    const setConversation = (num, name) => {
        document.querySelectorAll('.option').forEach(function(element) {
            element.style.border= '';
        })
        let element = document.getElementsByClassName('option')[num]
        element.style.border= '2px solid yellow';
        setConversationName(name);
        setConversationNum(num);
        chooseConversation(num);
    }

    const settopic = (num) => {
        document.querySelectorAll('.option').forEach(function(element) {
            element.style.border= '';
        })
        let element = document.getElementsByClassName('option')[num]
        element.style.border= '2px solid yellow';
        chooseTopic(num)
    }

    const chooseConversation = (conversationPlay) => {
        setDisplayStep1(false)
        let topics = [];
        switch(conversationPlay){
            case 0:
                topics = [
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/color.png'),
                        text: "Candy Bar",
                        completed: freeplay.level4.favorite.candy.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/animal.png'),
                        text: "Movie",
                        completed: freeplay.level4.favorite.movie.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/food.png'),
                        text: "Song",
                        completed: freeplay.level4.favorite.song.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/game.png'),
                        text: "Game",
                        completed: freeplay.level4.favorite.game.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/outside.png'),
                        text: "Book",
                        completed: freeplay.level4.favorite.book.unlocked

                    }
                ];
                setTopics(topics);
                setCelebrateVoice(getVideo('appfiles/greet/greet_celebrate_record_awesome.mp3', login))
                setCelebrateText('Record yourself in an excited voice and say, "I am awesome!"')
                if (Object.values(freeplay.level4.favorite).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level4.favorite).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 1:
                topics = [
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Happy_resized.png"),
                        text: "Happy",
                        completed: freeplay.level4.feeling.happy.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Sad_resized.png"),
                        text: "Sad",
                        completed: freeplay.level4.feeling.sad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Calm_resized.png"),
                        text: "Calm",
                        completed: freeplay.level4.feeling.calm.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Mad_resized.png"),
                        text: "Mad",
                        completed: freeplay.level4.feeling.mad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Confident_resized.png"),
                        text: "Confident",
                        completed: freeplay.level4.feeling.confident.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Nervous_resized.png"),
                        text: "Nervous",
                        completed: freeplay.level4.feeling.nervous.unlocked

                    },
                ];
                setTopics(topics);
                setCelebrateVoice(getVideo('appfiles/answer/answer_celebrate_record_amazing.mp3', login))
                setCelebrateText('Record yourself in an excited voice and say, "I am amazing!"')
                if (Object.values(freeplay.level4.feeling).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level4.feeling).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 2:
                topics = [
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Happy_resized.png"),
                        text: "Happy",
                        completed: freeplay.level4.listening.happy.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Sad_resized.png"),
                        text: "Sad",
                        completed: freeplay.level4.listening.sad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Calm_resized.png"),
                        text: "Calm",
                        completed: freeplay.level4.listening.calm.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Mad_resized.png"),
                        text: "Mad",
                        completed: freeplay.level4.listening.mad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Confident_resized.png"),
                        text: "Confident",
                        completed: freeplay.level4.listening.confident.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Nervous_resized.png"),
                        text: "Nervous",
                        completed: freeplay.level4.listening.nervous.unlocked

                    },
                ];
                setTopics(topics);
                setCelebrateVoice(getVideo('appfiles/close/close_celebrate_record_believe.mp3', login))
                setCelebrateText('Record yourself in an excited voice and say, "I believe in me!"')
                if (Object.values(freeplay.level4.listening).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level4.listening).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 3:
                topics = [
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/favorite_subject.png'),
                        text: "Favorite thing to do with friends",
                        completed: freeplay.level4.friends.thing.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/outside.png'),
                        text: "Favorite thing to do with family",
                        completed: freeplay.level4.friends.family.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/animal.png'),
                        text: "Favorite place to go",
                        completed: freeplay.level4.friends.place.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/food.png'),
                        text: "Favorite holiday",
                        completed: freeplay.level4.friends.holiday.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/favorite_fun.png'),
                        text: "Favorite way to relax",
                        completed: freeplay.level4.friends.relax.unlocked

                    },
                ];
                setTopics(topics);
                if (Object.values(freeplay.level4.friends).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level4.friends).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 4:
                topics = [
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Sad_resized.png"),
                        text: "Sad",
                        completed: freeplay.level4.solution.sad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Mad_resized.png"),
                        text: "Mad",
                        completed: freeplay.level4.solution.mad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Nervous_resized.png"),
                        text: "Nervous",
                        completed: freeplay.level4.solution.nervous.unlocked

                    },
                ];
                setTopics(topics);
                setCelebrateVoice(getVideo('appfiles/respond/respond_celebrate_record_do_all.mp3', login))
                setCelebrateText('Record yourself in an excited voice and say, "I can do it all!"')
                if (Object.values(freeplay.level4.solution).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level4.solution).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 5:
                topics = [
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/seat_taken.png'),
                        text: "Lunch",
                        completed: freeplay.level4.conflict.lunch.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/dino_toy.png'),
                        text: "Recess",
                        completed: freeplay.level4.conflict.recess.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/shovel.png'),
                        text: "Lunch Line",
                        completed: freeplay.level4.conflict.line.unlocked

                    },
                    {
                        img: generateImageUrl('images/Module8Images/Module8NavImages/JourneyMap_Mod3_Day8.png'),
                        text: "Group Project",
                        completed: freeplay.level4.conflict.project.unlocked

                    },
                    {
                        img: generateImageUrl('images/Module4Images/Reward_Camera.png'),
                        text: "Hurt Feelings",
                        completed: freeplay.level4.conflict.hurt.unlocked

                    },
                ];
                setTopics(topics);
                if (Object.values(freeplay.level4.conflict).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level4.conflict).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 6:
                topics = [
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/feed_birds.png'),
                        text: "Learn about Birds",
                        completed: freeplay.level4.advocacy.bird.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/buy_tickets.png'),
                        text: "Learn about Trains",
                        completed: freeplay.level4.advocacy.train.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/ask_monkey.png'),
                        text: "Ask for Directions",
                        completed: freeplay.level4.advocacy.direction.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/teacher.jpg'),
                        text: "Ask for Help",
                        completed: freeplay.level4.advocacy.help.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/ask_napkin.png'),
                        text: "Wrong Snack",
                        completed: freeplay.level4.advocacy.snack.unlocked 

                    },
                ];
                setTopics(topics);
                if (Object.values(freeplay.level4.advocacy).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level4.advocacy).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 7:
                // Objects to be pushed into the array
                topics = [
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/snow_cone.png'),
                        text: "Snow Cone Stand",
                        completed: freeplay.level4.community.cone.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/beach_topics.png'),
                        text: "Beach",
                        completed: freeplay.level4.community.guard.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/fast_food_topic.png'),
                        text: "Fast Food",
                        completed: freeplay.level4.community.food.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/saloon_topic.png'),
                        text: "Salon",
                        completed: freeplay.level4.community.salon.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/bakery_topic.png'),
                        text: "Bakery",
                        completed: freeplay.level4.community.bakery.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/cinema_topic.png'),
                        text: "Movie Theater",
                        completed: freeplay.level4.community.theater.unlocked

                    },
                ];
                setTopics(topics);
                if (Object.values(freeplay.level4.community).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level4.community).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            default:
                break;
        }
        setDisplayStep2(true)
        // setDisplayGame(true)
    }

    const chooseTopic = (topicPlay) => {
        setDisplayStep2(false);
        let codes = [];
        let celebrateAudios = [];
        let celebrateTexts = [];
        let conversations = [];
        let afterConversation = [];
        switch(conversationNum){
            case 0:
                conversations = [
                    [
                        {text: 'Your friend: Greet your friend.', sender: 'friend'},
                        {text: 'You: Greet your friend.', sender: 'student'},
                        {text:'Your friend: Ask your friend a question about their favorite candy bar.', sender: 'friend'},
                        {text: 'You: Answer your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'},
                        {text: 'You: Ask your friend a question about their favorite candy bar.', sender: 'student'},
                        {text: 'Your friend: Answer your friend’s question.', sender: 'friend'},
                        {text: 'You: Respond to your friend’s answer.', sender: 'student'},
                        {text: 'Your friend: Close the conversation with your friend.', sender: 'friend'},
                        {text: 'You: Close the conversation with your friend.', sender: 'student'}
                    ],
                    [
                        {text: 'Your friend: Greet your friend.', sender: 'friend'},
                        {text: 'You: Greet your friend.', sender: 'student'},
                        {text:'Your friend: Ask your friend a question about their favorite movie.', sender: 'friend'},
                        {text: 'You: Answer your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'},
                        {text: 'You: Ask your friend a question about their favorite movie.', sender: 'student'},
                        {text: 'Your friend: Answer your friend’s question.', sender: 'friend'},
                        {text: 'You: Respond to your friend’s answer.', sender: 'student'},
                        {text: 'Your friend: Close the conversation with your friend.', sender: 'friend'},
                        {text: 'You: Close the conversation with your friend.', sender: 'student'}
                    ],
                    [
                        {text: 'Your friend: Greet your friend.', sender: 'friend'},
                        {text: 'You: Greet your friend.', sender: 'student'},
                        {text: 'Your friend: Ask your friend a question about their favorite song.', sender: 'friend'},
                        {text: 'You: Answer your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'},
                        {text: 'You: Ask your friend a question about their favorite song.', sender: 'student'},
                        {text: 'Your friend: Answer your friend’s question.', sender: 'friend'},
                        {text: 'You: Respond to your friend’s answer.', sender: 'student'},
                        {text: 'Your friend: Close the conversation with your friend.', sender: 'friend'},
                        {text: 'You: Close the conversation with your friend.', sender: 'student'}
                    ],
                    [
                        {text: 'Your friend: Greet your friend.', sender: 'friend'},
                        {text: 'You: Greet your friend.', sender: 'student'},
                        {text: 'Your friend: Ask your friend a question about their favorite game.', sender: 'friend'},
                        {text: 'You: Answer your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'},
                        {text: 'You: Ask your friend a question about their favorite game.', sender: 'student'},
                        {text: 'Your friend: Answer your friend’s question.', sender: 'friend'},
                        {text: 'You: Respond to your friend’s answer.', sender: 'student'},
                        {text: 'Your friend: Close the conversation with your friend.', sender: 'friend'},
                        {text: 'You: Close the conversation with your friend.', sender: 'student'}
                    ],
                    [
                        {text: 'Your friend: Greet your friend.', sender: 'friend'},
                        {text: 'You: Greet your friend.', sender: 'student'},
                        {text: 'Your friend: Ask your friend a question about their favorite book.', sender: 'friend'},
                        {text: 'You: Answer your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'},
                        {text: 'You: Ask your friend a question about their favorite book.', sender: 'student'},
                        {text: 'Your friend: Answer your friend’s question.', sender: 'friend'},
                        {text: 'You: Respond to your friend’s answer.', sender: 'student'},
                        {text: 'Your friend: Close the conversation with your friend.', sender: 'friend'},
                        {text: 'You: Close the conversation with your friend.', sender: 'student'}
                    ]
                ];
                afterConversation = [
                    {text: 'Your friend: Ask, “Why is that your favorite?”', sender: 'friend'},
                    {text: 'You: Answer your friend’s question.', sender: 'student'},
                    {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'},
                    {text: 'You: Ask, “Why is that your favorite?”', sender: 'student'},
                    {text: 'You: Answer your friend’s question.', sender: 'student'},
                    {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'},
                    {text: 'Your friend: Ask, “Do you have another favorite?”', sender: 'friend'},
                    {text: 'You: Answer your friend’s question.', sender: 'student'},
                    {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'},
                    {text: 'You: Ask, “Do you have another favorite?”', sender: 'student'},
                    {text: 'You: Answer your friend’s question.', sender: 'student'},
                    {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'}
                ]
                codes = [
                    'CANDY',
                    'MOVIE',
                    'SONG',
                    'GAME',
                    'BOOK',
                ];
                setValuationQuestions([
                    "Did you use the 5 foundational skills? (eye contact, listening, smile, posture, distance)", 
                    "Did you greet your friend? (hi, hello, it is good to see you, etc.)", 
                    "Did you answer your friend’s question?", 
                    "Did you ask your friend a question?", 
                    "Did you respond to your friend’s answer? (that is great, cool, nice, etc.)",
                    "Did you close the conversation with your friend? (goodbye, bye, see you later, etc.)",
                ]);
                if(studentName !== ''){
                    //replace the text "You" with the student name
                    //conversation.map is not a function, so we need to use a for loop
                    for(let i = 0; i < conversations[topicPlay].length; i++){
                        conversations[topicPlay][i].text = conversations[topicPlay][i].text.replace('You:', `${studentName}:`);
                    }
                    for(let i = 0; i < afterConversation.length; i++){
                        afterConversation[i].text = afterConversation[i].text.replace('You:', `${studentName}:`);
                    }
                }
                if(friendName !== ''){
                    for(let i = 0; i < conversations[topicPlay].length; i++){
                        conversations[topicPlay][i].text = conversations[topicPlay][i].text.replace('Your friend:', `${friendName}:`);
                    }
                    for(let i = 0; i < afterConversation.length; i++){
                        afterConversation[i].text = afterConversation[i].text.replace('Your friend:', `${friendName}:`);
                    }
                }
                setPractice(
                    <Conversation
                        finish={() => {setDisplayStep3(false); setDisplayCoin(true)}}
                        close={() => {setDisplayStep3(false); setDisplayStep2(true)}}
                        selectedStudentCharacter={selectedStudentCharacter}
                        selectedFriendCharacter={selectedFriendCharacter}
                        selectedConversation={conversations[topicPlay]}
                        topicName={"Favorite Things: " + topics[topicPlay].text}
                    />
                  );
                setAfterConversation(
                    <Conversation
                        finish={() => {dispatch({type: `FREEPLAY_SET_LEVEL4_FAVORITE_${codes[topicPlay]}`, payload: 1}); setDisplayStep4(false); setDisplayCoinAfterConversation(true)}}
                        close={() => {setDisplayStep4(false); setDisplayStep2(true)}}
                        selectedStudentCharacter={selectedStudentCharacter}
                        selectedFriendCharacter={selectedFriendCharacter}
                        selectedConversation={afterConversation}
                        topicName={"Favorite Things: " + topics[topicPlay].text}
                        influencerid={influencers[topicPlay]}
                        levelUp={true}
                    />
                );
                setTopicName(`FAVORITE_${codes[topicPlay]}`)
                break;
            case 1:

                conversations = [
                    [
                        {text: 'Your friend: Ask, “What makes you feel happy?”', sender: 'friend'},
                        {text: 'You: Answer your friend’s question. (I feel ______ when ______.)', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer. (I’m glad you feel ______ when ______.)', sender: 'friend'},
                        {text: 'You: Thank your friend.', sender: 'student'}
                    ],
                    [
                        {text: 'Your friend: Ask, “What makes you feel sad?”', sender: 'friend'},
                        {text: 'You: Answer your friend’s question. (I feel ______ when ______.)', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer. (I’m sorry you feel ______ when ______.)', sender: 'friend'},
                        {text: 'You: Thank your friend.', sender: 'student'}
                    ],
                    [
                        {text: 'Your friend: Ask, “What makes you feel calm?”', sender: 'friend'},
                        {text: 'You: Answer your friend’s question. (I feel ______ when ______.)', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer. (I’m glad you feel ______ when ______.)', sender: 'friend'},
                        {text: 'You: Thank your friend.', sender: 'student'}
                    ],
                    [
                        {text: 'Your friend: Ask, “What makes you feel mad?”', sender: 'friend'},
                        {text: 'You: Answer your friend’s question. (I feel ______ when ______.)', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer. (I’m sorry you feel ______ when ______.)', sender: 'friend'},
                        {text: 'You: Thank your friend.', sender: 'student'}
                    ],
                    [
                        {text: 'Your friend: Ask, “What makes you feel confident?”', sender: 'friend'},
                        {text: 'You: Answer your friend’s question. (I feel ______ when ______.)', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer. (I’m glad you feel ______ when ______.)', sender: 'friend'},
                        {text: 'You: Thank your friend.', sender: 'student'}
                    ],
                    [
                        {text: 'Your friend: Ask, “What makes you feel nervous?”', sender: 'friend'},
                        {text: 'You: Answer your friend’s question. (I feel ______ when ______.)', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer. (I’m sorry you feel ______ when ______.)', sender: 'friend'},
                        {text: 'You: Thank your friend.', sender: 'student'}
                    ]
                ]
                afterConversation = [
                    {text: 'Your friend: Ask, “Can you tell me a story of when you felt that way?”', sender: 'friend'},
                    {text: 'You: Answer your friend’s question.', sender: 'student'},
                    {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'},
                    {text: 'Your friend: Ask, “What else makes you feel that way?”', sender: 'friend'},
                    {text: 'You: Answer your friend’s question.', sender: 'student'},
                    {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'},
                ]
                codes = [
                    'HAPPY',
                    'SAD',
                    'CALM',
                    'MAD',
                    'CONFIDENT',
                    'NERVOUS'
                ];
                setValuationQuestions([
                    "Did you use the 5 foundational skills? (eye contact, listening, smile, posture, distance)", 
                    "Did you tell your friend how you feel and why? (For example: I feel_____when_____.)"
                ]);
                if(studentName !== ''){
                    //replace the text "You" with the student name
                    //conversation.map is not a function, so we need to use a for loop
                    for(let i = 0; i < conversations[topicPlay].length; i++){
                        conversations[topicPlay][i].text = conversations[topicPlay][i].text.replace('You:', `${studentName}:`);
                    }
                    for(let i = 0; i < afterConversation.length; i++){
                        afterConversation[i].text = afterConversation[i].text.replace('You:', `${studentName}:`);
                    }
                }
                if(friendName !== ''){
                    for(let i = 0; i < conversations[topicPlay].length; i++){
                        conversations[topicPlay][i].text = conversations[topicPlay][i].text.replace('Your friend:', `${friendName}:`);
                    }
                    for(let i = 0; i < afterConversation.length; i++){
                        afterConversation[i].text = afterConversation[i].text.replace('Your friend:', `${friendName}:`);
                    }
                }
                setPractice(
                    <Conversation
                        finish={() => {setDisplayStep3(false); setDisplayCoin(true)}}
                        close={() => {setDisplayStep3(false); setDisplayStep2(true)}}
                        selectedStudentCharacter={selectedStudentCharacter}
                        selectedFriendCharacter={selectedFriendCharacter}
                        selectedConversation={conversations[topicPlay]}
                        topicName={'Talk About Feelings: ' + topics[topicPlay].text}
                    />
                  );
                setAfterConversation(
                    <Conversation
                        finish={() => {dispatch({type: `FREEPLAY_SET_LEVEL4_FEELING_${codes[topicPlay]}`, payload: 1}); setDisplayStep4(false); setDisplayCoinAfterConversation(true)}}
                        close={() => {setDisplayStep4(false); setDisplayStep2(true)}}
                        selectedStudentCharacter={selectedStudentCharacter}
                        selectedFriendCharacter={selectedFriendCharacter}
                        selectedConversation={afterConversation}
                        topicName={'Talk About Feelings: ' + topics[topicPlay].text}
                        influencerid={influencers[topicPlay]}
                        levelUp={true}
                    />
                );
                setTopicName(`FEELING_${codes[topicPlay]}`)
                break;
            case 2:
                conversations = [
                    [
                        {text: 'You: Ask your friend what makes them feel happy.', sender: 'student'},
                        {text: 'Your friend: Answer your friend’s question. (I feel ______ when ______.)', sender: 'friend'},
                        {text: 'You: Respond to your friend’s answer. (I’m glad you feel ______ when ______.)', sender: 'student'},
                        {text: 'Your friend: Thank your friend.', sender: 'friend'}
                    ],
                    [
                        {text: 'You: Ask your friend what makes them feel sad.', sender: 'student'},
                        {text: 'Your friend: Answer your friend’s question. (I feel ______ when ______.)', sender: 'friend'},
                        {text: 'You: Respond to your friend’s answer. (I’m sorry you feel ______ when ______.)', sender: 'student'},
                        {text: 'Your friend: Thank your friend.', sender: 'friend'}
                    ],
                    [
                        {text: 'You: Ask your friend what makes them feel calm.', sender: 'student'},
                        {text: 'Your friend: Answer your friend’s question. (I feel ______ when ______.)', sender: 'friend'},
                        {text: 'You: Respond to your friend’s answer. (I’m glad you feel ______ when ______.)', sender: 'student'},
                        {text: 'Your friend: Thank your friend.', sender: 'friend'}
                    ],
                    [
                        {text: 'You: Ask your friend what makes them feel mad.', sender: 'student'},
                        {text: 'Your friend: Answer your friend’s question. (I feel ______ when ______.)', sender: 'friend'},
                        {text: 'You: Respond to your friend’s answer. (I’m sorry you feel ______ when ______.)', sender: 'student'},
                        {text: 'Your friend: Thank your friend.', sender: 'friend'}
                    ],
                    [
                        {text: 'You: Ask your friend what makes them feel confident.', sender: 'student'},
                        {text: 'Your friend: Answer your friend’s question. (I feel ______ when ______.)', sender: 'friend'},
                        {text: 'You: Respond to your friend’s answer. (I’m glad you feel ______ when ______.)', sender: 'student'},
                        {text: 'Your friend: Thank your friend.', sender: 'friend'}
                    ],
                    [
                        {text: 'You: Ask your friend what makes them feel nervous.', sender: 'student'},
                        {text: 'Your friend: Answer your friend’s question. (I feel ______ when ______.)', sender: 'friend'},
                        {text: 'You: Respond to your friend’s answer. (I’m sorry you feel ______ when ______.)', sender: 'student'},
                        {text: 'Your friend: Thank your friend.', sender: 'friend'}
                    ]
                ]
                afterConversation = [
                    {text: 'You: Ask, “Can you tell me a story of when you felt that way?”', sender: 'student'},
                    {text: 'Your friend: Answer your friend’s question.', sender: 'friend'},
                    {text: 'You: Respond to your friend’s answer.', sender: 'student'},
                    {text: 'You: Ask, “What else makes you feel that way?”', sender: 'student'},
                    {text: 'Your friend: Answer your friend’s question.', sender: 'friend'},
                    {text: 'You: Respond to your friend’s answer.', sender: 'student'}
                ]

                codes = [
                    'HAPPY',
                    'SAD',
                    'CALM',
                    'MAD',
                    'CONFIDENT',
                    'NERVOUS'
                ];
                setValuationQuestions([
                    "Did you use the 5 foundational skills? (eye contact, listening, smile, posture, distance)", 
                    "Did you respond to your friend as an active listener? (For example: I am ______ that makes you feel ______.)"
                ]);
                if(studentName !== ''){
                    //replace the text "You" with the student name
                    //conversation.map is not a function, so we need to use a for loop
                    for(let i = 0; i < conversations[topicPlay].length; i++){
                        conversations[topicPlay][i].text = conversations[topicPlay][i].text.replace('You:', `${studentName}:`);
                    }
                    for(let i = 0; i < afterConversation.length; i++){
                        afterConversation[i].text = afterConversation[i].text.replace('You:', `${studentName}:`);
                    }
                }
                if(friendName !== ''){
                    for(let i = 0; i < conversations[topicPlay].length; i++){
                        conversations[topicPlay][i].text = conversations[topicPlay][i].text.replace('Your friend:', `${friendName}:`);
                    }
                    for(let i = 0; i < afterConversation.length; i++){
                        afterConversation[i].text = afterConversation[i].text.replace('Your friend:', `${friendName}:`);
                    }
                }
                setPractice(
                    <Conversation
                        finish={() => {setDisplayStep3(false); setDisplayCoin(true)}}
                        close={() => {setDisplayStep3(false); setDisplayStep2(true)}}
                        selectedStudentCharacter={selectedStudentCharacter}
                        selectedFriendCharacter={selectedFriendCharacter}
                        selectedConversation={conversations[topicPlay]}
                        topicName={'Talk About Feelings: ' + topics[topicPlay].text}
                    />
                  );
                setAfterConversation(
                    <Conversation
                        finish={() => {dispatch({type: `FREEPLAY_SET_LEVEL4_LISTENING_${codes[topicPlay]}`, payload: 1}); setDisplayStep4(false); setDisplayCoinAfterConversation(true)}}
                        close={() => {setDisplayStep4(false); setDisplayStep2(true)}}
                        selectedStudentCharacter={selectedStudentCharacter}
                        selectedFriendCharacter={selectedFriendCharacter}
                        selectedConversation={afterConversation}
                        topicName={'Talk About Feelings: ' + topics[topicPlay].text}
                        influencerid={influencers[topicPlay]}
                        levelUp={true}
                    />
                );
                setTopicName(`LISTENING_${codes[topicPlay]}`)
                break;
            case 3:
                conversations = [
                    [
                        {text: "Step 1: Be Kind", sender: "step"},
                        {text: 'You: Greet your friend and ask their name.', sender: 'student'},
                        {text: 'Your friend: Greet your friend and answer their question.', sender: 'friend'},
                        {text: "Step 2: Ask Questions", sender: "step"},
                        {text: 'You: Ask your friend a question about their favorite thing to do with friends.', sender: 'student'},
                        {text: 'Your friend: Answer your friend’s question.', sender: 'friend'},
                        {text: 'You: Respond to your friend’s answer.', sender: 'student'},
                        {text: 'Your friend: Ask your friend a question about their favorite thing to do with friends.', sender: 'friend'},
                        {text: 'You: Answer your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'},
                        {text: 'You: Close the conversation with your friend.', sender: 'student'},
                        {text: 'Your friend: Close the conversation with your friend.', sender: 'friend'},
                    ],
                    [
                        {text: "Step 1: Be Kind", sender: "step"},
                        {text: 'You: Greet your friend and ask their name.', sender: 'student'},
                        {text: 'Your friend: Greet your friend and answer their question.', sender: 'friend'},
                        {text: "Step 2: Ask Questions", sender: "step"},
                        {text: 'You: Ask your friend a question about their favorite thing to do with family.', sender: 'student'},
                        {text: 'Your friend: Answer your friend’s question.', sender: 'friend'},
                        {text: 'You: Respond to your friend’s answer.', sender: 'student'},
                        {text: 'Your friend: Ask your friend a question about their favorite thing to do with family.', sender: 'friend'},
                        {text: 'You: Answer your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'},
                        {text: 'You: Close the conversation with your friend.', sender: 'student'},
                        {text: 'Your friend: Close the conversation with your friend.', sender: 'friend'},
                    ],
                    [
                        {text: "Step 1: Be Kind", sender: "step"},
                        {text: 'You: Greet your friend and ask their name.', sender: 'student'},
                        {text: 'Your friend: Greet your friend and answer their question.', sender: 'friend'},
                        {text: "Step 2: Ask Questions", sender: "step"},
                        {text: 'You: Ask your friend a question about their favorite place to go.', sender: 'student'},
                        {text: 'Your friend: Answer your friend’s question.', sender: 'friend'},
                        {text: 'You: Respond to your friend’s answer.', sender: 'student'},
                        {text: 'Your friend: Ask your friend a question about their favorite place to go.', sender: 'friend'},
                        {text: 'You: Answer your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'},
                        {text: 'You: Close the conversation with your friend.', sender: 'student'},
                        {text: 'Your friend: Close the conversation with your friend.', sender: 'friend'},
                    ],
                    [
                        {text: "Step 1: Be Kind", sender: "step"},
                        {text: 'You: Greet your friend and ask their name.', sender: 'student'},
                        {text: 'Your friend: Greet your friend and answer their question.', sender: 'friend'},
                        {text: "Step 2: Ask Questions", sender: "step"},
                        {text: 'You: Ask your friend a question about their favorite holiday.', sender: 'student'},
                        {text: 'Your friend: Answer your friend’s question.', sender: 'friend'},
                        {text: 'You: Respond to your friend’s answer.', sender: 'student'},
                        {text: 'Your friend: Ask your friend a question about their favorite holiday.', sender: 'friend'},
                        {text: 'You: Answer your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'},
                        {text: 'You: Close the conversation with your friend.', sender: 'student'},
                        {text: 'Your friend: Close the conversation with your friend.', sender: 'friend'},
                    ],
                    [
                        {text: "Step 1: Be Kind", sender: "step"},
                        {text: 'You: Greet your friend and ask their name.', sender: 'student'},
                        {text: 'Your friend: Greet your friend and answer their question.', sender: 'friend'},
                        {text: "Step 2: Ask Questions", sender: "step"},
                        {text: 'You: Ask your friend a question about their favorite way to relax.', sender: 'student'},
                        {text: 'Your friend: Answer your friend’s question.', sender: 'friend'},
                        {text: 'You: Respond to your friend’s answer.', sender: 'student'},
                        {text: 'Your friend: Ask your friend a question about their favorite way to relax.', sender: 'friend'},
                        {text: 'You: Answer your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'},
                        {text: 'You: Close the conversation with your friend.', sender: 'student'},
                        {text: 'Your friend: Close the conversation with your friend.', sender: 'friend'},
                    ]
                ]
                afterConversation = [
                    [
                        {text: 'Your friend: Ask, “Who are the friends you like to play with?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “What do you like to play with your friends?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “When do you like to play with your friends?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “Where do you like to play with your friends?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “Why do your friends like playing with you?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “How should you treat your friends?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'}
                    ],
                    [
                        {text: 'Your friend: Ask, “Who is in your family?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “What is a family tradition you have?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “When do you like to be with your family?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “Where do you like to go with your family?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “Why do you like spending time with your family?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “How should you treat your family?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'}
                    ],
                    [
                        {text: 'Your friend: Ask, “Who do you like to go to this place with?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “What do you like to do at this place?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “When do you like to go to this place?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “Where else do you like to go?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “Why do you like to go to this other place?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “How often do you go to these places?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'}
                    ],
                    [
                        {text: 'Your friend: Ask, “Who do you like to be with on this holiday?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “What is your favorite part of this holiday?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “When do you start getting ready for this holiday?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “Where do you celebrate this holiday?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “Why do you like this holiday?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “How does this holiday make you feel?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'}
                    ],
                    [
                        {text: 'Your friend: Ask, “Who do you like to relax with?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “What do else do you like to do to relax?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “When do you like to relax?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “Where do you like to relax?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “Why should you relax?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'},
                        {text: 'Your friend: Ask, “How should you treat others when you’re trying to relax?”', sender: 'friend'},
                        {text: 'You: Respond to your friend’s question.', sender: 'student'}
                    ]
                ]

                setValuationQuestions([
                    "Did you use the 5 foundational skills? (eye contact, listening, smile, posture, distance)", 
                    "Step 1: Be Kind. Did you greet your friend and ask their name in a kind way?",
                    "Step 2: Ask Questions. Did you ask your friend a question to get to know them?"
                ]);

                codes = [
                    'THING',
                    'FAMILY',
                    'PLACE',
                    'HOLIDAY',
                    'RELAX',
                ];
                if(studentName !== ''){
                    for(let i = 0; i < conversations[topicPlay].length; i++){
                        conversations[topicPlay][i].text = conversations[topicPlay][i].text.replace('You:', `${studentName}:`);
                    }
                    for(let i = 0; i < afterConversation[topicPlay].length; i++){
                        afterConversation[topicPlay][i].text = afterConversation[topicPlay][i].text.replace('You:', `${studentName}:`);
                    }
                }
                if(friendName !== ''){
                    for(let i = 0; i < conversations[topicPlay].length; i++){
                        conversations[topicPlay][i].text = conversations[topicPlay][i].text.replace('Your friend:', `${friendName}:`);
                    }
                    for(let i = 0; i < afterConversation[topicPlay].length; i++){
                        afterConversation[topicPlay][i].text = afterConversation[topicPlay][i].text.replace('Your friend:', `${friendName}:`);
                    }
                }
                celebrateAudios = ['appfiles/friends_bullying/friends_bullying_celebrate_record_kind.mp3',
                    'appfiles/friends_bullying/friends_bullying_celebrate_record_questions.mp3',
                    'appfiles/friends_bullying/friends_bullying_celebrate_record_not_bully.mp3',
                    'appfiles/friends_bullying/friends_bullying_celebrate_record_stop_bullying.mp3',
                    'appfiles/friends_bullying/friends_bullying_celebrate_record_making_friends.mp3']
                celebrateTexts = [`Record yourself in an excited voice and say, "I am amazing because I am kind!"`,
                    `Record yourself in an excited voice and say, "I am amazing because I ask good questions!"`,
                    `Record yourself in an excited voice and say, "I am amazing because I do not bully others!"`,
                    `Record yourself in an excited voice and say, "I am amazing because I tell others to stop bullying!"`,
                    `Record yourself in an excited voice and say, "I am amazing because I am good at making friends!"`]
                setPractice(
                    <Conversation
                        finish={() => {setDisplayStep3(false); setDisplayCoin(true)}}
                        close={() => {setDisplayStep3(false); setDisplayStep2(true)}}
                        selectedStudentCharacter={selectedStudentCharacter}
                        selectedFriendCharacter={selectedFriendCharacter}
                        selectedConversation={conversations[topicPlay]}
                        topicName={'Making Friends: ' + topics[topicPlay].text}
                    />
                );
                setAfterConversation(
                    <Conversation
                        finish={() => {dispatch({type: `FREEPLAY_SET_LEVEL4_FRIENDS_${codes[topicPlay]}`, payload: 1}); setDisplayStep4(false); setDisplayCoinAfterConversation(true)}}
                        close={() => {setDisplayStep4(false); setDisplayStep2(true)}}
                        selectedStudentCharacter={selectedStudentCharacter}
                        selectedFriendCharacter={selectedFriendCharacter}
                        selectedConversation={afterConversation[topicPlay]}
                        topicName={'Making Friends: ' + topics[topicPlay].text}
                        influencerid={influencers[topicPlay]}
                        levelUp={true}
                    />
                );
                setCelebrateVoice(getVideo(celebrateAudios[topicPlay], login))
                setCelebrateText(celebrateTexts[topicPlay])
                setTopicName(`FRIENDS_${codes[topicPlay]}`)
                break;
            case 4:
                conversations = [
                    [
                        {text: 'Your Friend’s Turn: Ask, “What makes you feel sad?”', sender: 'friend'},
                        {text: 'You: Answer your friend’s question.', sender: 'student'},
                        {text: 'Your Friend’s Turn: Respond to your friend’s answer (I’m sorry you feel ______ when ______.) and ask, “What is a solution?”', sender: 'friend'},
                        {text: 'You: Answer your friend’s question.', sender: 'student'},
                        {text: 'Your Friend’s Turn: Respond to your friend’s answer.', sender: 'friend'}
                    ],
                    [
                        {text: 'Your Friend’s Turn: Ask, “What makes you feel mad?”', sender: 'friend'},
                        {text: 'You: Answer your friend’s question.', sender: 'student'},
                        {text: 'Your Friend’s Turn: Respond to your friend’s answer.', sender: 'friend'},
                        {text: 'Your Friend’s Turn: Ask, “What is a solution?”', sender: 'friend'},
                        {text: 'You: Answer your friend’s question.', sender: 'student'},
                        {text: 'Your Friend’s Turn: Respond to your friend’s answer.', sender: 'friend'}
                    ],
                    [
                        {text: 'Your Friend’s Turn: Ask, “What makes you feel nervous?”', sender: 'friend'},
                        {text: 'You: Answer your friend’s question.', sender: 'student'},
                        {text: 'Your Friend’s Turn: Respond to your friend’s answer.', sender: 'friend'},
                        {text: 'Your Friend’s Turn: Ask, “What is a solution?”', sender: 'friend'},
                        {text: 'You: Answer your friend’s question.', sender: 'student'},
                        {text: 'Your Friend’s Turn: Respond to your friend’s answer.', sender: 'friend'}
                    ]
                ]

                afterConversation = [
                    {text: 'Your Friend’s Turn: Ask, “Why is that a good solution?”', sender: 'friend'},
                    {text: 'You: Respond to your friend’s answer.', sender: 'student'},
                    {text: 'Your Friend’s Turn: Ask, “What is another solution to your problem?”', sender: 'friend'},
                    {text: 'You: Respond to your friend’s answer.', sender: 'student'}
                ]

                codes = [
                    'SAD',
                    'MAD',
                    'NERVOUS'
                ];
                setValuationQuestions([
                    "Did you use the 5 foundational skills? (eye contact, listening, smile, posture, distance)", 
                    "Did you tell your friend how you feel and why? (For example: I feel ______ when ______.)",
                    "Did you come up with a fair solution to change your feelings?"
                ]);
                if(studentName !== ''){
                    for(let i = 0; i < conversations[topicPlay].length; i++){
                        conversations[topicPlay][i].text = conversations[topicPlay][i].text.replace('You:', `${studentName}:`);
                    }
                    for(let i = 0; i < afterConversation.length; i++){
                        afterConversation[i].text = afterConversation[i].text.replace('You:', `${studentName}:`);
                    }
                }
                if(friendName !== ''){
                    for(let i = 0; i < conversations[topicPlay].length; i++){
                        conversations[topicPlay][i].text = conversations[topicPlay][i].text.replace('Your friend:', `${friendName}:`);
                    }
                    for(let i = 0; i < afterConversation.length; i++){
                        afterConversation[i].text = afterConversation[i].text.replace('Your friend:', `${friendName}:`);
                    }
                }
                setPractice(
                    <Conversation
                        finish={() => {setDisplayStep3(false); setDisplayCoin(true)}}
                        close={() => {setDisplayStep3(false); setDisplayStep2(true)}}
                        selectedStudentCharacter={selectedStudentCharacter}
                        selectedFriendCharacter={selectedFriendCharacter}
                        selectedConversation={conversations[topicPlay]}
                        topicName={'Talk About Feelings: ' + topics[topicPlay].text}
                    />
                );
                setAfterConversation(
                    <Conversation
                        finish={() => {dispatch({type: `FREEPLAY_SET_LEVEL4_SOLUTION_${codes[topicPlay]}`, payload: 1}); setDisplayStep4(false); setDisplayCoinAfterConversation(true)}}
                        close={() => {setDisplayStep4(false); setDisplayStep2(true)}}
                        selectedStudentCharacter={selectedStudentCharacter}
                        selectedFriendCharacter={selectedFriendCharacter}
                        selectedConversation={afterConversation}
                        topicName={'Talk About Feelings: ' + topics[topicPlay].text}
                        influencerid={influencers[topicPlay]}
                        levelUp={true}
                    />
                );
                setTopicName(`SOLUTION_${codes[topicPlay]}`)
                break;    
            case 5:

                conversations = [
                    [
                        {text: 'Step 1: Be Calm', sender: 'step'},
                        {text: 'You: Take a deep breath and use a calm voice and calm hands. (not a recording)', sender: 'student'},
                        {text: 'Step 2: Talk About It', sender: 'step'},
                        {text: 'You: Say, “I feel _____ because ______. Can you tell me why?”', sender: 'student'},
                        {text: 'Your friend: Say, “I’m sorry. I was sitting by another friend and didn’t see you.”', sender: 'friend'},
                        {text: 'Step 3: Make It Better', sender: 'step'},
                        {text: 'You: Respond and tell your friend how you can make it better.', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'}
                    ],
                    [
                        {text: 'Step 1: Be Calm', sender: 'step'},
                        {text: 'You: Take a deep breath and use a calm voice and calm hands. (not a recording)', sender: 'student'},
                        {text: 'Step 2: Talk About It', sender: 'step'},
                        {text: 'You: Say, “I feel _____ because ______. Can you tell me why you want to play with the ball?”', sender: 'student'},
                        {text: 'Your friend: Say, “I’m sorry. I wanted to play with the ball because ______.”', sender: 'friend'},
                        {text: 'Step 3: Make It Better', sender: 'step'},
                        {text: 'You: Respond and tell your friend how you can make it better.', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'}
                    ],
                    [
                        {text: 'Step 1: Be Calm', sender: 'step'},
                        {text: 'You: Take a deep breath and use a calm voice and calm hands. (not a recording)', sender: 'student'},
                        {text: 'Step 2: Talk About It', sender: 'step'},
                        {text: 'You: Say, “I feel _____ because ______. Can you tell me why you did that?”', sender: 'student'},
                        {text: 'Your friend: Say, “I’m sorry. I ______.”', sender: 'friend'},
                        {text: 'Step 3: Make It Better', sender: 'step'},
                        {text: 'You: Respond and tell your friend how you can make it better.', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'}
                    ],
                    [
                        {text: 'Step 1: Be Calm', sender: 'step'},
                        {text: 'You: Take a deep breath and use a calm voice and calm hands. (not a recording)', sender: 'student'},
                        {text: 'Step 2: Talk About It', sender: 'step'},
                        {text: 'You: Say, “I feel _____ because ______. Can you tell me why?”', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'},
                        {text: 'Step 3: Make It Better', sender: 'step'},
                        {text: 'You: Respond and tell your friend how you can make it better.', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'}
                    ],
                    [
                        {text: 'Step 1: Be Calm', sender: 'step'},
                        {text: 'You: Take a deep breath and use a calm voice and calm hands. (not a recording)', sender: 'student'},
                        {text: 'Step 2: Talk About It', sender: 'step'},
                        {text: 'You: Say, “I feel _____ because ______. Can you tell me why?”', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'},
                        {text: 'Step 3: Make It Better', sender: 'step'},
                        {text: 'You: Respond and tell your friend how you can make it better.', sender: 'student'},
                        {text: 'Your friend: Respond to your friend’s answer.', sender: 'friend'}
                    ]
                ]
                afterConversation = [
                    [
                        {text: `Discuqss some reasons why it’s important to tell people how you feel when you get your feelings hurt.`, sender: 'step'},
                        {text: 'What can you do better next time if someone says something about you?', sender: 'step'},
                    ],
                    [
                        {text: `Discuss how you can share the ball at recess.`, sender: 'step'},
                        {text: 'What can you do better next time if your friend wants to play with the same thing you want to play with?', sender: 'step'},
                    ],
                    [
                        {text: `Discuss some reasons why kids might cut in front of you in the lunch line.`, sender: 'step'},
                        {text: 'What can you do better next time if someone cuts in front of you in the lunch line?', sender: 'step'},
                    ],
                    [
                        {text: `Discuss some reasons why it’s important to listen and use other kids' ideas.`, sender: 'step'},
                        {text: 'What can you do better next time if someone wants to use their idea instead of yours?', sender: 'step'},
                    ],
                    [
                        {text: `Discuss some reasons why it’s important to tell people how you feel when you get your feelings hurt.`, sender: 'step'},
                        {text: 'What can you do better next time if someone says something about you?', sender: 'step'},
                    ]
                ]
                codes = [
                    'LUNCH',
                    'RECESS',
                    'LINE',
                    'PROJECT',
                    'HURT',
                ];
                setValuationQuestions([
                    "Did you use the 5 foundational skills? (eye contact, listening, smile, posture, distance)", 
                    "Step 1: Be Calm. Did you calm down by taking a deep breath?",
                    "Step 2: Talk About It. Did you say how you feel and why?",
                    "Step 3: Make It Better. Did you and your friend come up with a solution?"
                ]);

                codes = [
                    'LUNCH',
                    'RECESS',
                    'LINE',
                    'PROJECT',
                    'HURT',
                ];
                if(studentName !== ''){
                    for(let i = 0; i < conversations[topicPlay].length; i++){
                        conversations[topicPlay][i].text = conversations[topicPlay][i].text.replace('You:', `${studentName}:`);
                    }
                    for(let i = 0; i < afterConversation[topicPlay].length; i++){
                        afterConversation[topicPlay][i].text = afterConversation[topicPlay][i].text.replace('You:', `${studentName}:`);
                    }
                }
                if(friendName !== ''){
                    for(let i = 0; i < conversations[topicPlay].length; i++){
                        conversations[topicPlay][i].text = conversations[topicPlay][i].text.replace('Your friend:', `${friendName}:`);
                    }
                    for(let i = 0; i < afterConversation[topicPlay].length; i++){
                        afterConversation[topicPlay][i].text = afterConversation[topicPlay][i].text.replace('Your friend:', `${friendName}:`);
                    }
                }
                celebrateAudios = ['appfiles/resolve_conflict/resolve_conflict_celebrate_calm.mp3',
                    'appfiles/resolve_conflict/resolve_conflict_celebrate_feelings.mp3',
                    'appfiles/resolve_conflict/resolve_conflict_celebrate_listener.mp3',
                    'appfiles/resolve_conflict/resolve_conflict_celebrate_solve_problems.mp3',
                    'appfiles/resolve_conflict/resolve_conflict_celebrate_better.mp3']
                celebrateTexts = [`Record yourself in an excited voice and say, "I am a very important person because I know when to be calm!"`,
                    `Record yourself in an excited voice and say, "I am a very important person because I can talk about my feelings!"`,
                    `Record yourself in an excited voice and say, "I am a very important person because I am a good listener!"`,
                    `Record yourself in an excited voice and say, "I am a very important person because I solve problems with friends!"`,
                    `Record yourself in an excited voice and say, "I am a very important person because I can make things better!"`]
                setPractice(
                    <Conversation
                        finish={() => {setDisplayStep3(false); setDisplayCoin(true)}}
                        close={() => {setDisplayStep3(false); setDisplayStep2(true)}}
                        selectedStudentCharacter={selectedStudentCharacter}
                        selectedFriendCharacter={selectedFriendCharacter}
                        selectedConversation={conversations[topicPlay]}
                        topicName={'Talk About Feelings: ' + topics[topicPlay].text}
                    />
                );
                setAfterConversation(
                    <Conversation
                        finish={() => {dispatch({type: `FREEPLAY_SET_LEVEL4_CONFLICT_${codes[topicPlay]}`, payload: 1}); setDisplayStep4(false); setDisplayCoinAfterConversation(true)}}
                        close={() => {setDisplayStep4(false); setDisplayStep2(true)}}
                        selectedStudentCharacter={selectedStudentCharacter}
                        selectedFriendCharacter={selectedFriendCharacter}
                        selectedConversation={afterConversation[topicPlay]}
                        topicName={'Talk About Feelings: ' + topics[topicPlay].text}
                        influencerid={influencers[topicPlay]}
                        levelUp={true}
                    />
                );
                setTopicName(`CONFLICT_${codes[topicPlay]}`)
                setCelebrateVoice(getVideo(celebrateAudios[topicPlay], login))
                setCelebrateText(celebrateTexts[topicPlay])
                break;
            case 6:
                conversations = [
                    [
                        {text: 'Step 1: Think About What You Want to Say', sender: 'step'},
                        {text: 'You: Think about a question you want to ask the bird trainer.', sender: 'student'},
                        {text: 'Step 2: Believe in Yourself', sender: 'step'},
                        {text: 'You and Your friend Together: Sing the Joyful Jingle', sender: 'step'},
                        {text: 'Step 3: Achieve It', sender: 'step'},
                        {text: 'Your friend: Say, “Hi! I am a bird trainer.”', sender: 'friend'},
                        {text: 'You: Greet the bird trainer and ask your question.', sender: 'student'},
                        {text: 'Your friend: Answer the question.', sender: 'friend'},
                        {text: 'You: Respond to their answer and close the conversation.', sender: 'student'},
                        {text: 'Your friend: Close the conversation.', sender: 'friend'},
                    ],
                    [
                        {text: 'Step 1: Think About What You Want to Say', sender: 'step'},
                        {text: 'You: Think about a question you want to ask the train conductor.', sender: 'student'},
                        {text: 'Step 2: Believe in Yourself', sender: 'step'},
                        {text: 'You and Your friend Together: Sing the Joyful Jingle', sender: 'step'},
                        {text: 'Step 3: Achieve It', sender: 'step'},
                        {text: 'Your friend: Say, “Hi! I am a train conductor. How can I help you?”', sender: 'friend'},
                        {text: 'You: Greet the train conductor and ask your question.', sender: 'student'},
                        {text: 'Your friend: Answer the question.', sender: 'friend'},
                        {text: 'You: Respond to their answer and close the conversation.', sender: 'student'},
                        {text: 'Your friend: Close the conversation.', sender: 'friend'},
                    ],
                    [
                        {text: 'Step 1: Think About What You Want to Say', sender: 'step'},
                        {text: 'You: Think about how you want to ask the zoo keeper for directions.', sender: 'student'},
                        {text: 'Step 2: Believe in Yourself', sender: 'step'},
                        {text: 'You and Your friend Together: Sing the Joyful Jingle', sender: 'step'},
                        {text: 'Step 3: Achieve It', sender: 'step'},
                        {text: 'Your friend: Say, “Hi! I am a zoo keeper. How can I help you?”', sender: 'friend'},
                        {text: 'You: Greet the zoo keeper and ask for directions to see the monkeys.', sender: 'student'},
                        {text: 'Your friend: Answer the question.', sender: 'friend'},
                        {text: 'You: Respond to their answer and close the conversation.', sender: 'student'},
                        {text: 'Your friend: Close the conversation.', sender: 'friend'},
                    ],
                    [
                        {text: 'Step 1: Think About What You Want to Say', sender: 'step'},
                        {text: 'You: Think about how you want to ask the reptile worker for help.', sender: 'student'},
                        {text: 'Step 2: Believe in Yourself', sender: 'step'},
                        {text: 'You and Your friend Together: Sing the Joyful Jingle', sender: 'step'},
                        {text: 'Step 3: Achieve It', sender: 'step'},
                        {text: 'Your friend: Say, “Hi! I work with reptiles. How can I help you?”', sender: 'friend'},
                        {text: 'You: Greet the worker and ask for help.', sender: 'student'},
                        {text: 'Your friend: Answer the question.', sender: 'friend'},
                        {text: 'You: Respond to their answer and close the conversation.', sender: 'student'},
                        {text: 'Your friend: Close the conversation.', sender: 'friend'},
                    ],
                    [
                        {text: 'Step 1: Think About What You Want to Say', sender: 'step'},
                        {text: 'You: Think about how you want to ask the snack shack worker for help.', sender: 'student'},
                        {text: 'Step 2: Believe in Yourself', sender: 'step'},
                        {text: 'You and Your friend Together: Sing the Joyful Jingle', sender: 'step'},
                        {text: 'Step 3: Achieve It', sender: 'step'},
                        {text: 'Your friend: Say, “Hi! I work at the snack shack. How can I help you?”', sender: 'friend'},
                        {text: 'You: Greet the worker and ask for help on your order.', sender: 'student'},
                        {text: 'Your friend: Answer the question.', sender: 'friend'},
                        {text: 'You: Respond to their answer and close the conversation.', sender: 'student'},
                        {text: 'Your friend: Close the conversation.', sender: 'friend'},
                    ]
                ]

                afterConversation = [
                    [
                        {text: 'You: Have you always liked birds?', sender: 'student'},
                        {text: 'Your friend: Answer with yes or no.', sender: 'friend'},
                        {text: 'You: Do you like eagles or hawks better?', sender: 'student'},
                        {text: 'Your friend: Answer the question.', sender: 'friend'},
                        {text: 'You: What is your favorite thing about being a bird trainer?', sender: 'student'},
                        {text: 'Your friend: Answer the question.', sender: 'friend'}
                    ],
                    [
                        {text: 'You: Have you always liked trains?', sender: 'student'},
                        {text: 'Your friend: Answer with yes or no.', sender: 'friend'},
                        {text: 'Your Turn: Do you like trains or buses better?', sender: 'student'},
                        {text: 'Your friend: Answer the question.', sender: 'friend'},
                        {text: 'You: What is your favorite thing about being a train conductor?', sender: 'student'},
                        {text: 'Your friend: Answer the question.', sender: 'friend'}
                    ],
                    [
                        {text: 'Your friend: Why is it important to ask a safe adult for directions?', sender: 'friend'},
                        {text: 'You: Answer the question.', sender: 'student'},
                        {text: 'Your friend: If you can’t find the zoo keeper, who else can you ask for directions?', sender: 'friend'},
                        {text: 'You: Answer the question.', sender: 'student'},
                        {text: 'Your friend: Why is it important to ask questions and self-advocate when you need help?', sender: 'friend'},
                        {text: 'You: Answer the question.', sender: 'student'}
                    ],
                    [
                        {text: 'Your friend: Have you ever gotten lost?', sender: 'friend'},
                        {text: 'You: Answer with yes or no.', sender: 'student'},
                        {text: 'Your friend: If you get lost, should you hide, or ask for help?', sender: 'friend'},
                        {text: 'You: Answer the question.', sender: 'student'},
                        {text: 'Your friend: What other things can you do when you get lost?', sender: 'friend'},
                        {text: 'You: Answer the question.', sender: 'student'}
                    ],
                    [
                        {text: 'Your friend: Have you ever gotten a wrong order?', sender: 'friend'},
                        {text: 'You: Answer with yes or no.', sender: 'student'},
                        {text: 'Your friend: If you get the wrong order, would you keep it or ask for the right one?', sender: 'friend'},
                        {text: 'You: Answer the question.', sender: 'student'},
                        {text: 'Your friend: Why is it okay to ask for help if you got the wrong order?', sender: 'friend'},
                        {text: 'You: Answer the question.', sender: 'student'}
                    ]
                ]

                if(studentName !== ''){
                    for(let i = 0; i < conversations[topicPlay].length; i++){
                        conversations[topicPlay][i].text = conversations[topicPlay][i].text.replace('You:', `${studentName}:`);
                    }
                    for(let i = 0; i < afterConversation[topicPlay].length; i++){
                        afterConversation[topicPlay][i].text = afterConversation[topicPlay][i].text.replace('You:', `${studentName}:`);
                    }
                }
                if(friendName !== ''){
                    for(let i = 0; i < conversations[topicPlay].length; i++){
                        conversations[topicPlay][i].text = conversations[topicPlay][i].text.replace('Your friend:', `${friendName}:`);
                    }
                    for(let i = 0; i < afterConversation[topicPlay].length; i++){
                        afterConversation[topicPlay][i].text = afterConversation[topicPlay][i].text.replace('Your friend:', `${friendName}:`);
                    }
                }
                setValuationQuestions([
                    "Did you use the 5 foundational skills? (eye contact, listening, smile, posture, distance)", 
                    "Step 1: Think About What You Want to Say. Did you think about what you want to say?",
                    "Step 2: Believe in Yourself. Did you sing the Joyful Jingle?",
                    "Step 3: Achieve It. Did you greet your friend and ask them a question?",
                ]);
                  
                codes = [
                    'BIRD',
                    'TRAIN',
                    'DIRECTION',
                    'HELP',
                    'SNACK',
                ];
                celebrateAudios = ['appfiles/self_advocacy/self_advocacy_celebrate_record_think.mp3',
                    'appfiles/self_advocacy/self_advocacy_celebrate_record_believe.mp3',
                    'appfiles/self_advocacy/self_advocacy_celebrate_record_achieve.mp3',
                    'appfiles/self_advocacy/self_advocacy_celebrate_record_speak_up.mp3',
                    'appfiles/self_advocacy/self_advocacy_celebrate_record_stand_up.mp3']
                celebrateTexts = [`Record yourself in an excited voice and say, "I can do it all, because I think about what I want to say or do!"`,
                    `Record yourself in an excited voice and say, "I can do it all, because I believe in myself!"`,
                    `Record yourself in an excited voice and say, "I can do it all, because I achieve great things!"`,
                    `Record yourself in an excited voice and say, "I can do it all, because I can speak up for myself!"`,
                    `Record yourself in an excited voice and say, "I can do it all, because I can stand up for myself!"`]
                setPractice(
                    <Conversation
                        finish={() => {setDisplayStep3(false); setDisplayCoin(true)}}
                        close={() => {setDisplayStep3(false); setDisplayStep2(true)}}
                        selectedStudentCharacter={selectedStudentCharacter}
                        selectedFriendCharacter={selectedFriendCharacter}
                        selectedConversation={conversations[topicPlay]}
                        topicName={'Talk About Feelings: ' + topics[topicPlay].text}
                    />
                );
                setAfterConversation(
                    <Conversation
                        finish={() => {dispatch({type: `FREEPLAY_SET_LEVEL4_ADVOCACY_${codes[topicPlay]}`, payload: 1}); setDisplayStep4(false); setDisplayCoinAfterConversation(true)}}
                        close={() => {setDisplayStep4(false); setDisplayStep2(true)}}
                        selectedStudentCharacter={selectedStudentCharacter}
                        selectedFriendCharacter={selectedFriendCharacter}
                        selectedConversation={afterConversation[topicPlay]}
                        topicName={'Talk About Feelings: ' + topics[topicPlay].text}
                        influencerid={influencers[topicPlay]}
                        levelUp={true}
                    />
                );
                setTopicName(`ADVOCACY_${codes[topicPlay]}`)
                setCelebrateVoice(getVideo(celebrateAudios[topicPlay], login))
                setCelebrateText(celebrateTexts[topicPlay])
                break;
            case 7:
                conversations = [
                    [
                        {text: 'Practice Using Good Manners', sender: 'step'},
                        {text: 'Before you practice the conversation remember to use good manners', sender: 'step'},
                        {text: 'Step 1: How I act: Remember to look at their eyes, listen, smile, keep your body tall and stand at arms length.', sender: 'step'},
                        {text: 'Step 2: What I Say: Use kind words.', sender: 'step'},
                        {text: 'Step 3: How I Say It:  Talk to the community workers in a calm voice.', sender: 'step'},
                        {text: 'Your friend: Say, “Hi! My job is to make snow cones. How can I help you?”', sender: 'friend'},
                        {text: 'You: Greet the worker and order a snow cone using good manners.', sender: 'student'},
                        {text: 'Your friend: Say, “Sure! Would you like small, medium or large?”', sender: 'friend'},
                        {text: 'You: Answer the question using good manners.', sender: 'student'},
                        {text: 'Your friend: Respond to their answer.', sender: 'friend'},
                        {text: 'You: Use good manners and then close the conversation.', sender: 'student'},
                        {text: 'Your friend: Use good manners and then close the conversation.', sender: 'friend'},
                    ],
                    [
                        {text: 'Practice Using Good Manners', sender: 'step'},
                        {text: 'Before you practice the conversation remember to use good manners', sender: 'step'},
                        {text: 'Step 1: How I Act: Remember to look at their eyes, listen, smile, keep your body tall and stand at arm’s length.', sender: 'step'},
                        {text: 'Step 2: What I Say: Use kind words.', sender: 'step'},
                        {text: 'Step 3: How I Say It: Talk to the community workers in a calm voice.', sender: 'step'},
                        {text: 'Your friend: Say, “Hi! I am a lifeguard and I am here to help keep people safe.”', sender: 'friend'},
                        {text: 'You: Greet the lifeguard.', sender: 'student'},
                        {text: 'Your friend: Ask, “Can you please clean up your trash when you leave?”', sender: 'friend'},
                        {text: 'You: Answer the lifeguard using good manners.', sender: 'student'},
                        {text: 'Your friend: Respond to their answer.', sender: 'friend'},
                        {text: 'You: Use good manners and then close the conversation.', sender: 'student'},
                        {text: 'Your friend: Use good manners and then close the conversation.', sender: 'friend'},
                    ],
                    [
                        {text: 'Practice Using Good Manners', sender: 'step'},
                        {text: 'Before you practice the conversation remember to use good manners', sender: 'step'},
                        {text: 'Step 1: How I act: Remember to look at their eyes, listen, smile, keep your body tall and stand at arms length.', sender: 'step'},
                        {text: 'Step 2: What I Say: Use kind words.', sender: 'step'},
                        {text: 'Step 3: How I Say It: Talk to the community workers in a calm voice.', sender: 'step'},
                        {text: 'Your friend: Say, “I am a fast food worker and you just spilled your drink and need me to help you.”', sender: 'friend'},
                        {text: 'You: Greet the worker and ask for help using good manners.', sender: 'student'},
                        {text: 'Your friend: Respond to their answer.', sender: 'friend'},
                        {text: 'You: Use good manners and then close the conversation.', sender: 'student'},
                        {text: 'Your friend: Use good manners and then close the conversation.', sender: 'friend'},
                    ],
                    [
                        {text: 'Practice Caring for Yourself, Others and the World', sender: 'step'},
                        {text: 'Scenario: You need a haircut.', sender: 'step'},
                        {text: 'Step 1: See It', sender: 'step'},
                        {text: 'You see that you need a haircut.', sender: 'step'},
                        {text: 'Step 2: Fix It', sender: 'step'},
                        {text: 'You get your hair cut.', sender: 'step'},
                        {text: 'Step 3: Make It Better', sender: 'step'},
                        {text: 'You give the hair stylist a compliment and thank them.', sender: 'step'},
                        {text: 'Now, let’s practice the conversation.', sender: 'step'},
                        {text: 'Your friend: Say, “Hi! I cut people’s hair. How can I help you?”', sender: 'friend'},
                        {text: 'You: Greet the stylist and ask for a haircut.', sender: 'student'},
                        {text: 'Your friend: Say, “Sure! How would you like it cut?”', sender: 'friend'},
                        {text: 'You: Respond to the question.', sender: 'student'},
                        {text: 'Your friend: Say, “Okay! You’re all done. I hope you enjoy it.”', sender: 'friend'},
                        {text: 'You: Give a compliment and close the conversation using good manners.', sender: 'student'},
                        {text: 'Your friend: Close the conversation using good manners.', sender: 'friend'},
                    ],
                    [
                        {text: 'Practice Caring for Yourself, Others and the World', sender: 'step'},
                        {text: 'Scenario: You help someone open the door.', sender: 'step'},
                        {text: 'Step 1: See It', sender: 'step'},
                        {text: 'You see that the baker’s hands are full and cannot open the door.', sender: 'step'},
                        {text: 'Step 2: Fix It', sender: 'step'},
                        {text: 'You hold the door open for the baker.', sender: 'step'},
                        {text: 'Step 3: Make It Better', sender: 'step'},
                        {text: 'You make sure the door closes all the way to keep the cold air outside.', sender: 'step'},
                        {text: 'Now, let’s practice the conversation.', sender: 'step'},
                        {text: 'Your friend: Say, “Hi! Welcome to the bakery. I’ll be with you in a moment.”', sender: 'friend'},
                        {text: 'You: Greet the baker.', sender: 'student'},
                        {text: 'Your friend: Say, “I just need to take a dozen cupcakes to a customer outside.”', sender: 'friend'},
                        {text: 'You: Ask the baker if they need help opening the door.', sender: 'student'},
                        {text: 'Your friend: Respond to their answer.', sender: 'friend'},
                        {text: 'You: Respond to their answer.', sender: 'student'},
                    ],
                    [
                        {text: 'Practice Caring for Yourself, Others and the World', sender: 'step'},
                        {text: 'Scenario: You need to put your plastic water bottle in the recycle bin.', sender: 'step'},
                        {text: 'Step 1: See It', sender: 'step'},
                        {text: 'You have a plastic water bottle that needs to be thrown away.', sender: 'step'},
                        {text: 'Step 2: Fix It', sender: 'step'},
                        {text: 'You find out where the recycle bin is and put it in there.', sender: 'step'},
                        {text: 'Step 3: Make It Better', sender: 'step'},
                        {text: 'You see other empty plastic water bottles on the theater ground and you also throw those away.', sender: 'step'},
                        {text: 'Now, let’s practice the conversation.', sender: 'step'},
                        {text: 'Your friend: Say, “Hi! I work at the movie theater. How can I help you?”', sender: 'friend'},
                        {text: 'You: Greet the worker and ask where the recycle bin is.', sender: 'student'},
                        {text: 'Your friend: Respond to their question.', sender: 'friend'},
                        {text: 'You: Close the conversation using good manners.', sender: 'student'},
                        {text: 'Your friend: Close the conversation using good manners.', sender: 'friend'},
                    ]
                ]
                afterConversation = [
                    [
                        {text: 'Step 1: How I Act:', sender: 'step'},
                        {text: 'Discuss why it’s important to look at the worker’s eyes, listen, smile, keep your body tall and stand at arm’s length when ordering.', sender: 'step'},
                        {text: 'Step 2: What I Say:', sender: 'step'},
                        {text: 'Discuss why it’s important to use kind words (please, thank you, excuse me and I’m sorry) when ordering.', sender: 'step'},
                        {text: 'Step 3: How I Say It:', sender: 'step'},
                        {text: 'Discuss why it’s important to talk in a calm voice when ordering.', sender: 'step'},
                    ],
                    [
                        {text: 'Step 1: How I Act:', sender: 'step'},
                        {text: 'Discuss why it’s important to look at the worker’s eyes, listen, smile, keep your body tall and stand at arm’s length when asking for help.', sender: 'step'},
                        {text: 'Step 2: What I Say:', sender: 'step'},
                        {text: 'Discuss why it’s important to use kind words (please, thank you, excuse me and I’m sorry) when asking for help.', sender: 'step'},
                        {text: 'Step 3: How I Say It:', sender: 'step'},
                        {text: 'Discuss when it’s okay to talk in a whisper voice, calm voice and a loud voice at the beach.', sender: 'step'},
                    ],
                    [
                        {text: 'Step 1: How I Act:', sender: 'step'},
                        {text: 'Discuss why it’s important to look at the worker’s eyes, listen, smile, keep your body tall and stand at arm’s length when asking for help.', sender: 'step'},
                        {text: 'Step 2: What I Say:', sender: 'step'},
                        {text: 'Discuss why it’s important to use kind words (please, thank you, excuse me and I’m sorry) when asking for help.', sender: 'step'},
                        {text: 'Step 3: How I Say It:', sender: 'step'},
                        {text: 'Discuss when it’s okay to talk in a whisper voice, calm voice and a loud voice when you need help.', sender: 'step'},
                    ],
                    [
                        {text: 'Step 1: How I Act:', sender: 'step'},
                        {text: 'Discuss ways to take care of yourself. (Brush teeth, eat healthy, wash hands, etc.)', sender: 'step'},
                        {text: 'Step 2: What I Say:', sender: 'step'},
                        {text: 'Discuss why it’s important to take care of yourself. (Healthy teeth, healthy body, clean hands, etc.)', sender: 'step'},
                        {text: 'Step 3: How I Say It:', sender: 'step'},
                        {text: 'Discuss how you can take better care of yourself and go the extra mile. (Brush your teeth and wipe the water off the counter, eat a healthy snack and then wash your plate, wash your hands and throw the paper towel in the garbage can, etc.)', sender: 'step'},
                    ],
                    [
                        {text: 'Step 1: See It', sender: 'step'},
                        {text: 'Discuss ways to take care of others.', sender: 'step'},
                        {text: 'Step 2: Fix It', sender: 'step'},
                        {text: 'Discuss why it’s important to take care of others.', sender: 'step'},
                        {text: 'Step 3: Make It Better', sender: 'step'},
                        {text: 'Discuss how you can take better care of others and go the extra mile.', sender: 'step'},
                    ],
                    [
                        {text: 'Step 1: See It', sender: 'step'},
                        {text: 'Discuss ways to take care of the world.', sender: 'step'},
                        {text: 'Step 2: Fix It', sender: 'step'},
                        {text: 'Discuss why it’s important to take care of the world.', sender: 'step'},
                        {text: 'Step 3: Make It Better', sender: 'step'},
                        {text: 'Discuss how you can take better care of the world and go the extra mile.', sender: 'step'},
                    ]
                    
                ]
                if(studentName !== ''){
                    for(let i = 0; i < conversations[topicPlay].length; i++){
                        conversations[topicPlay][i].text = conversations[topicPlay][i].text.replace('You:', `${studentName}:`);
                    }
                    for(let i = 0; i < afterConversation[topicPlay].length; i++){
                        afterConversation[topicPlay][i].text = afterConversation[topicPlay][i].text.replace('You:', `${studentName}:`);
                    }
                }
                if(friendName !== ''){
                    for(let i = 0; i < conversations[topicPlay].length; i++){
                        conversations[topicPlay][i].text = conversations[topicPlay][i].text.replace('Your friend:', `${friendName}:`);
                    }
                    for(let i = 0; i < afterConversation[topicPlay].length; i++){
                        afterConversation[topicPlay][i].text = afterConversation[topicPlay][i].text.replace('Your friend:', `${friendName}:`);
                    }
                }
                
                setValuationQuestions([
                    "Step 1: How I act. Did you use the 5 foundational skills (eye contact, listening, smile, posture, distance)?", 
                    "Step 2: What I say: Did you use kind words?",
                    "Step 3: How I saw it: Did you talk in a calm voice?",
                    "Did you greet your friend?",
                    "Did you answer your friend’s question?",
                    "Did you close the conversation?"
                ]);

                codes = [
                    'CONE',
                    'GUARD',
                    'FOOD',
                    'SALON',
                    'BAKERY',
                    'THEATER'
                ];
                celebrateAudios = ['appfiles/manners/manners_celebrate_please.mp3',
                    'appfiles/manners/manners_celebrate_thank.mp3',
                    'appfiles/manners/manners_celebrate_calm.mp3',
                    'appfiles/manners/manners_celebrate_smile.mp3',
                    'appfiles/manners/manners_celebrate_body_tall.mp3',
                    'appfiles/caring/caring_celebrate_record_take_care_myself.mp3',
                    'appfiles/caring/caring_celebrate_record_take_care_others.mp3',
                    'appfiles/caring/caring_celebrate_record_take_care_world.mp3',
                    'appfiles/caring/caring_celebrate_record_see_fix.mp3',
                    'appfiles/caring/caring_celebrate_record_hard_things.mp3']
                celebrateTexts = [`Record yourself in an excited voice and say, "I am awesome because I say please!"`,
                    `Record yourself in an excited voice and say, "I am awesome because I say thank you!"`,
                    `Record yourself in an excited voice and say, "I am awesome because I talk in a calm voice."`,
                    `Record yourself in an excited voice and say, "I am awesome because I smile!"`,
                    `Record yourself in an excited voice and say, "I am awesome because I keep my body tall!"`,
                    `Record yourself in an excited voice and say, "I believe in me because I take care of myself!"`,
                    `Record yourself in an excited voice and say, "I believe in me because I take care of others!"`,
                    `Record yourself in an excited voice and say, "I believe in me, because I take care of the world!"`,
                    `Record yourself in an excited voice and say, "I believe in me, because I can see it, fix it and make it even better!"`,
                    `Record yourself in an excited voice and say, "I believe in me, because I can do hard things!"`]
                setPractice(
                    <Conversation
                        finish={() => {setDisplayStep3(false); setDisplayCoin(true)}}
                        close={() => {setDisplayStep3(false); setDisplayStep2(true)}}
                        selectedStudentCharacter={selectedStudentCharacter}
                        selectedFriendCharacter={selectedFriendCharacter}
                        selectedConversation={conversations[topicPlay]}
                        topicName={'Community Locations' + topics[topicPlay].text}
                    />
                );
                setAfterConversation(
                    <Conversation
                        finish={() => {dispatch({type: `FREEPLAY_SET_LEVEL4_COMMUNITY_${codes[topicPlay]}`, payload: 1}); setDisplayStep4(false); setDisplayCoinAfterConversation(true)}}
                        close={() => {setDisplayStep4(false); setDisplayStep2(true)}}
                        selectedStudentCharacter={selectedStudentCharacter}
                        selectedFriendCharacter={selectedFriendCharacter}
                        selectedConversation={afterConversation[topicPlay]}
                        topicName={'Community Locations' + topics[topicPlay].text}
                        influencerid={influencers[topicPlay]}
                        levelUp={true}
                    />
                );
                setTopicName(`COMMUNITY_${codes[topicPlay]}`)
                setCelebrateVoice(getVideo(celebrateAudios[topicPlay], login))
                setCelebrateText(celebrateTexts[topicPlay])
                break;
            default:
                break;
        }
        setDisplaySurpriseVideoIcon(false);
        setDisplayStep3(true)
        // setDisplayMatchGame(true)
        // setDisplayShare(true)
    }

    const onStop = (bought, data) => {
        const position = { x: data.x / clientWidth, y: data.y / clientHeight };
        freeplay.level4Decorate.items = freeplay.level4Decorate.items.map(item => 
            item === bought? {...item, position} : item
        );
        setBoughts(freeplay.level4Decorate.items)
    };

    const goBack = () => {
        if(displayChatChallenge){
            setDisplayChatChallenge(false);
            setDisplayStep2(true);
        }
        else if(displayStep1){
            setDisplayStep0(true);  
            setDisplayStep1(false)
        }
        else if(displayStep2){
            setDisplayStep1(true);  
            setDisplayStep2(false);
            setDisplaySurpriseVideoIcon(false);
        }
        else if(displayStep3){
            setDisplayStep2(true); 
            setDisplayStep3(false)
        }
        else if(displayStep3){
            setDisplayStep2(true); 
            setDisplayStep3(false)
        }
        else if(displayStep4){
            setDisplayStep3(true); 
            setDisplayStep4(false)
        }
        else if(displayValuation){
            setDisplayStep4(true); 
            setDisplayValuation(false)
        }
        else{
            navigate("/freeplay_2")
        }
    };

    const checkCompletion = async () => {
        dispatch({ type: `FREEPLAY_SET_LEVEL4_SHAREDCOIN`, payload: 0 });
        switch (conversationNum) {
            case 0:
                if (Object.values(freeplay.level4.favorite).filter(value => value.unlocked === 1).length === 5) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level4_favorite_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level4/masks/fish_mask.png')} animalName={'fish'} level={'level4'} topic={'favorite'} width={96} height={160} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_2");
                    }
                }
                else{
                    navigate("/freeplay_2");
                }
                break;
            case 1:
                if (Object.values(freeplay.level4.feeling).filter(value => value.unlocked === 1).length === 6) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level4_feeling_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level4/masks/octopus_mask.png')} animalName={'octopus'} level={'level4'} topic={'feeling'} width={130} height={200} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_2");
                    }
                }
                else{
                    navigate("/freeplay_2");
                }
                break;
            case 2:
                if (Object.values(freeplay.level4.listening).filter(value => value.unlocked === 1).length === 6) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level4_listening_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level4/masks/frog_mask.png')} animalName={'frog'} level={'level4'} topic={'listening'} width={95} height={160} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_2");
                    }
                }
                else{
                    navigate("/freeplay_2");
                }
                break;
            case 3:
                if (Object.values(freeplay.level4.friends).filter(value => value.unlocked === 1).length === 5) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level4_friends_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level4/masks/gnome_mask.png')} animalName={'gnome'} level={'level4'} topic={'friends'} width={80} height={140} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_2");
                    }
                }
                else{
                    navigate("/freeplay_2");
                }
                break;
            case 4:
                if (Object.values(freeplay.level4.solution).filter(value => value.unlocked === 1).length === 3) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level4_solution_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level4/masks/owl_mask.png')} animalName={'owl'} level={'level4'} topic={'solution'} width={110} height={190} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_2");
                    }
                }
                else{
                    navigate("/freeplay_2");
                }
                break;
            case 5:
                if (Object.values(freeplay.level4.conflict).filter(value => value.unlocked === 1).length === 5) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level4_conflict_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level4/masks/dinosaur_mask.png')} animalName={'dinosaur'} level={'level4'} topic={'conflict'} width={100} height={200} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_2");
                    }
                }
                else{
                    navigate("/freeplay_2");
                }
                break;
            case 6:
                if (Object.values(freeplay.level4.advocacy).filter(value => value.unlocked === 1).length === 5) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level4_advocacy_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level4/masks/sasquatch_mask.png')} animalName={'sasquatch'} level={'level4'} topic={'advocacy'} width={95} height={160} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_2");
                    }
                }
                else{
                    navigate("/freeplay_2");
                }
                break;
            case 7:
                if (Object.values(freeplay.level4.community).filter(value => value.unlocked === 1).length === 10) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level4_community_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level4/masks/alien_mask.png')} animalName={'alien'} level={'level4'} topic={'community'} width={95} height={160} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_2");
                    }
                }
                else{
                    navigate("/freeplay_2");
                }
                break;
            default:
                break;
        }
    };
    

    const retakePhoto = (item) => {
        let height = 160;
        let width = 95;
        switch(item.animal){
            case "fish":
                width = 96;  
                break;
            case "octopus":
                height = 200;
                width = 130;  
                break;
            case "gnome":
                height = 140;
                width = 80; 
                break;
            case "owl":
                height = 190;
                width = 110; 
                break;
            case "dinosaur":
                height = 200;
                width = 100; 
                break;
            default:
                break;
        }
        setAnimal(<Animal animal={generateImageUrl(`images/newDesign/FreePlay/level4/masks/${item.animal}_mask.png`)} animalName={item.animal} level={'level4'} topic={item.name} width={width} height={height} setDisplayAnimal={setDisplayAnimal}  getAnimals={getAnimals} finish={()=>{setDisplayStoreCharacter(true); setDisplayAnimal(false);}}/>)
        setDisplayStore(false);
        setDisplayStoreCharacter(false);
        setDisplayAnimal(true);
    }

    const getSurprise = async () => {
        let usePhoto = []
        switch(conversationNum){
            case 0:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FAVORITE_COLOR.mp4`,
                    },
                    {
                        video: `influencers/${influencers[0]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module16/Unit4_Mod1_SpecialReward_1.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FAVORITE_ANIMAL.mp4`,
                    },
                ];
                break;
            case 1:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FEELING_CONFIDENT.mp4`,
                    },
                    {
                        video: `influencers/${influencers[0]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module16/Unit4_Mod1_SpecialReward_2.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FEELING_HAPPY.mp4`,
                    },
                ];
                break;
            case 2:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_LISTENING_HAPPY.mp4`,
                    },
                    {
                        video: `influencers/${influencers[0]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module17/Unit4_Mod2_Special Dance 1.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_LISTENING_CALM.mp4`,
                    },
                ];
                break;
            case 3:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FRIENDS_SUBJECT.mp4`,
                    },
                    {
                        video: `influencers/${influencers[0]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module17/Unit4_Mod2_Special Dance 2.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FRIENDS_OUTSIDE.mp4`,
                    },
                ];
                break;
            case 4:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_SOLUTION_NERVOUS.mp4`,
                    },
                    {
                        video: `influencers/${influencers[2]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module18/Unit4_Mod3_SpecialReward_Dance 1.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_SOLUTION_SAD.mp4`,
                    },
                ];
                break;
            case 5:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_CONFLICT_SHOP.mp4`,
                    },
                    {
                        video: `influencers/${influencers[0]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module18/Unit4_Mod3_SpecialRewards_Dance 2.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_CONFLICT_PHOTO.mp4`,
                    },
                ];
                break;
            case 6:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_ADVOCACY_TRAIN.mp4`,
                    },
                    {
                        video: `influencers/${influencers[3]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module19/Unit4_Mod4_SpecialReward_Dance 1.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_ADVOCACY_CARE.mp4`,
                    },
                ];
                break;
            case 7:
            usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_COMMUNITY_FOOD.mp4`,
                    },
                    {
                        video: `influencers/${influencers[4]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module20/Unit4_Mod5_SpecialReward 1.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_COMMUNITY_THEATER.mp4`,
                    },
                ];
                break;
            default:
                break;
        }

        for (let i = 0; i < usePhoto.length; i++) {
            if(usePhoto[i].video.includes("media")){
                usePhoto[i].video = generateImageUrl(usePhoto[i].video)
            }
            else{
                await GetUserVideo(usePhoto[i].video, login).then((data) => {
                    usePhoto[i].video = data;
                });
            }
        }
        
        return usePhoto;
    };
    
    const playSurpriseVideo = async (intro = true) => {
        let music = ""
        switch(conversationNum){
            case 0:
                music = "appfiles/manners/manners_instrumental.m4a"
                break;
            case 1:
                music = "appfiles/manners/manners_instrumental.m4a"
                break;
            case 2:
                music = "appfiles/friends_bullying/friends_bullying_instrumental.m4a"
                break; 
            case 3:
                music = "appfiles/friends_bullying/friends_bullying_instrumental.m4a"
                break; 
            case 4:
                music = "appfiles/expressions/faces_student_instrumental.m4a"
                break; 
            case 5:
                music = "appfiles/expressions/faces_student_instrumental.m4a"
                break; 
            case 6:
                music = "appfiles/posture/posture_student_instrumental.m4a"
                break; 
            case 7:
                music = "appfiles/distance/distance_student_instrumental.m4a"
                break; 
            default:
                break;
        }
        await getSurprise().then((photo) => {
            setSurpriseVideo(
            <Surprise
                background={backgrounds[bgIdx]}
                music={getVideo(music, login)}
                // music={generateImageUrl('media/Freeplay/surprise_intrumental.mp3')}
                introVideo={intro ? 'd6c6b74e964a62fe8a9940bd860c/480.m3u8' : ""}
                slides={photo}
                level4={true}
                setDisplaySurprise={setDisplaySurpriseVideo}
            />
            );
        });
        setDisplaySurpriseVideo(true);
    };

    return (
        <>
        {displaySurpriseVideo && surpriseVideo}
        {!displaySurpriseVideo &&
        <div className='level4Body' style={{ backgroundImage: `url(${backgrounds[bgIdx]})`,  overflowY: "scroll"}}>
            {displayDecorate && !displayStore &&  !displayStoreCharacter &&<div className='decorate' style={{zIndex : !change ? 1 : 0}}>
                    {/* <h2><a onClick={() => {navigate("/freeplay_2")}}>&#60; BACK</a></h2> */}
                    {/* <img className='bin' id='bin' src={Bin}/> */}
                    <img alt='store button' className='store' src={Store} onClick={() => {setDisplayStore(true); setDisplayAnimal(false)}}/>
                    <footer>
                        <h2><a onClick={displayAnimal ? () => {setDisplayAnimal(false); setDisplayStoreCharacter(true)} : () => {navigate("/freeplay_2")}}>&#60; BACK</a></h2>
                    </footer> 
            </div>}
            {(displayStep0 || displayStep1 || displayStep2 || displayCoin || displayCelebrate || displayCoinAfterCelebrate || displayCoinAfterConversation || displayCoinAfterValuation || displayShare || displayChatChallenge) && <header>
                <div className='actions'>
                    {/* {(displayStep1 || displayStep2) && <h2><a onClick={goBack}>&#60; BACK</a></h2>} */}
                    {displaySurpriseVideoIcon && (
                        <img className='surprise' src={giftBtn} alt='Surprise Video' onClick={()=>{playSurpriseVideo(false)}} />
                    )}                
                </div>
                <div className='coins'>
                    <img alt='coin icon' src={coin}/>
                    {freeplay.level4Coin < 10 && <div className='coin1'>{freeplay.level4Coin}</div>}
                    {freeplay.level4Coin >= 10 && freeplay.level4Coin < 100 && <div className='coin10'>{freeplay.level4Coin}</div>}
                    {freeplay.level4Coin >= 100 && <div className='coin100'>{freeplay.level4Coin}</div>}
                </div>
            </header>}
            {(displayStep3 || displayStep4) && <header>
                <img
                    className='back-btn-ftb'
                    alt='back button'
                    src={Exit}
                    onClick={() => {
                        setDisplayStep3(false)
                        setDisplayStep4(false)
                        setDisplayStep1(true)
                    }}
                ></img>
            </header>}
            <footer>
                {(displayStep0 || displayStep1 || displayStep2 || displayStep3 || displayStep4 || displayValuation || displayChatChallenge) && <h2><a onClick={goBack}>&#60; BACK</a></h2>}
                {displayShare && <h2 style={{ position: "fixed", right: "40px", bottom: "20px",}}><a onClick={checkCompletion}>NEXT &#62;</a></h2>}
            </footer> 
            {displayStore && storeReady && <StorePage getAnimals={getAnimals} coin={freeplay.level4Coin} level={"LEVEL4"} decorate={freeplay.level4Decorate} bgs={backgrounds} setBgIdx={setBgIdx} buys={buys} boughts={boughts} setBoughts={setBoughts} close={setDisplayStore} animals={animals} setUpdate={setUpdate} update={update} setChange={setChange} retakePhoto={retakePhoto}/>}
            {displayStoreCharacter && storeReady && <StorePage getAnimals={getAnimals} coin={freeplay.level4Coin} level={"LEVEL4"} decorate={freeplay.level1Decorate} bgs={backgrounds} setBgIdx={setBgIdx} buys={buys} boughts={boughts} setBoughts={setBoughts} close={setDisplayStoreCharacter} animals={animals} setUpdate={setUpdate} update={update} setChange={setChange} retakePhoto={retakePhoto} character={true}/>}
            {displayStep0 && <Intro finish={()=>{setDisplayStep0(false); setDisplayStep1(true)}} setSelectedStudentCharacter={setSelectedStudentCharacter} setSelectedFriendCharacter={setSelectedFriendCharacter} setStudentName={setStudentName} setFriendName={setFriendName}/>}
            {displayStep1 && <div className='conversation'>
                <h2 className='header'>
                    Choose Your Conversation
                </h2>
                <h3 className='text'>
                    Click the conversation you want to practice
                </h3>
                <Container>
                    <Row xs={2} md={3} lg={4}>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(0, 'Favorite Things')}}>
                                <div className='text'>Favorite Things</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level4.favorite).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level4.favorite).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level4.favorite).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level4.favorite).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(1, 'Talk about Feelings')}}>
                                <div className='text'>Talk about Feelings</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level4.feeling).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level4.feeling).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level4.feeling).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level4.feeling).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(2, 'Active Listening')}}>
                                <div className='text'>Active Listening</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level4.listening).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level4.listening).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level4.listening).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level4.listening).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(3, 'Making Friends')}}>
                                <div className='text'>Making Friends</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level4.friends).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level4.friends).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level4.friends).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level4.friends).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(4, 'Solutions')}}>
                                <div className='text'>Solutions</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level4.solution).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level4.solution).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level4.solution).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level4.solution).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(5, 'Resolve Conflict')}}>
                                <div className='text'>Resolve Conflict</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level4.conflict).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level4.conflict).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level4.conflict).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level4.conflict).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(6, 'Self-Advocacy')}}>
                                <div className='text'>Self-Advocacy</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level4.advocacy).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level4.advocacy).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level4.advocacy).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level4.advocacy).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(7, 'Community Locations: Manners & Caring')}}>
                                <div className='text'>Community Locations</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level4.community).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level4.community).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level4.community).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level4.community).length} Completed</div>}
                            </div>
                        </Col>
    
                    </Row>
                </Container>
            </div>}
            {displayStep2 && <div className='topic'>
                <h2 className='header'>
                    {conversationName}
                </h2>
                <h3 className='text'>
                    Click the topic you want to practice
                </h3>
                <div className={`conversation_${conversationNum}`}>
                    <Container>
                        <Row xs={2} md={3} lg={4}>
                            {topics.map((topic, index) => (
                                <Col key={index}> 
                                    <div className='option' onClick={() => {settopic(index)}}>
                                        <div className='text'>{topic.text}</div>
                                        <div className='icon'>
                                            <img alt='topic icon' src={topic.img} />
                                        </div>
                                        {topic.completed === 1 && <div className='optionProgress'>Completed</div>}                                 
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </div>
                {/* Chat Challenge Button at Bottom */}
                <div className='chat-challenge-button-container'>
                    <button 
                        className={`chat-challenge-button ${Object.values(freeplay.level4[conversationNames[conversationNum]]).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level4[conversationNames[conversationNum]]).length ? 'unlocked' : 'locked'}`}
                        disabled={Object.values(freeplay.level4[conversationNames[conversationNum]]).filter(value => value.unlocked === 1).length !== Object.keys(freeplay.level4[conversationNames[conversationNum]]).length}
                        onClick={() => {
                            if (Object.values(freeplay.level4[conversationNames[conversationNum]]).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level4[conversationNames[conversationNum]]).length) {
                                const chatTopicName = conversationNum === 0 ? 'Animal' : 'Chat Challenge';
                                const flow = getChatChallengeFlow(conversationNum, chatTopicName);
                                setChatChallengeFlow(flow);
                                setChatChallengeTopicName(`${conversationName}: Chat Challenge`);
                                setDisplayStep2(false);
                                setDisplayChatChallenge(true);
                            }
                        }}
                    >
                        {Object.values(freeplay.level4[conversationNames[conversationNum]]).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level4[conversationNames[conversationNum]]).length ? (
                            <>
                                <span className='button-icon'>🏆</span>
                                <span className='button-text'>Take Chat Challenge</span>
                            </>
                        ) : (
                            <>
                                <span className='button-icon'>🔒</span>
                                <span className='button-text'>Complete all topics to unlock Chat Challenge</span>
                            </>
                        )}
                    </button>
                </div>
            </div>}
            {displayStep3 && practice}
            {displayCoin && <Coin level={'LEVEL4'} coin={freeplay.level4Coin} close={() => {setDisplayCoin(false); setDisplayStep4(true)}}/>}
            {displayStep4 && afterConversation}
            {displayCoinAfterConversation && <Coin level={'LEVEL4'} coin={freeplay.level4Coin} close={() => {setDisplayCoinAfterConversation(false); setDisplayValuation(true)}}/>}
            {displayValuation && <Valuation finish={() => {setDisplayValuation(false); setDisplayCoinAfterValuation(true)}} close={() => {setDisplayStep4(false); setDisplayStep2(true)}} name={conversationNames[conversationNum]}  day={getNestedLength(freeplay.level4)} questions={valuationQuestions} level4={true}/>}
            {displayCoinAfterValuation && <Coin level={'LEVEL4'} coin={freeplay.level4Coin} close={() => {setDisplayCoinAfterValuation(false); setDisplayCelebrate(true)}}/>}
            {displayCelebrate && <Celebrate
              voice1={celebrateVoice}
              voice2={getVideo('appfiles/eye_contact/crab_awesome_job.mp3', login)}
              text={celebrateText}
              name={`level4_celebration_${topicName}.mp4`}
              animation={getVideo('appfiles/greet/greet_awesome_job.gif', login)}
              close={() => {updateProgress(); setDisplayCelebrate(false); setDisplayCoinAfterCelebrate(true)}}
            />}
            {displayCoinAfterCelebrate && <Coin coin={freeplay.level4Coin} level={'LEVEL4'} close={() => {setDisplayCoinAfterCelebrate(false); setDisplayGame(true)}}/>}
            {displayGame && <Game checkCompletion={()=>{setDisplayShare(true); setDisplayGame(false)}} coin={freeplay.level4Coin} level={'LEVEL4'}/>}
            {displayShare && <Share setDisplayShare={setDisplayShare} checkCompletion={checkCompletion} sharedCoin={freeplay.level4SharedCoin}/>}
            {displayAnimal && animal}
            {displayChatChampion && (
                <ChatChallengeChampion
                    studentName={studentName}
                    animalImage={championAnimalImage}
                    music={generateImageUrl('media/Freeplay/celebration_music.mp3')}
                    close={() => {
                        setDisplayChatChampion(false);
                        setDisplayStep2(true);
                    }}
                />
            )}
            {displayChatChallenge && chatChallengeFlow && (
                <ChatChallenge
                    studentName={studentName}
                    friendName={friendName}
                    selectedStudentCharacter={selectedStudentCharacter}
                    selectedFriendCharacter={selectedFriendCharacter}
                    conversationFlow={chatChallengeFlow}
                    topicName={chatChallengeTopicName}
                    conversationNum={conversationNum}
                    name={conversationNames[conversationNum]}
                    finish={async () => {
                        setDisplayChatChallenge(false);
                        setDisplayChatChampion(true);
                        // Save Chat Challenge completion to backend
                        //await saveChatChallengeResult(conversationNames[conversationNum], true);
                    }}
                    close={() => {
                        setDisplayChatChallenge(false);
                        setDisplayStep2(true);
                    }}
                />
            )}     
            {prize && (
                <img
                    className='present'
                    style={{
                    width: '84px',
                    height: '100px',
                    marginLeft: '-42px',
                    zIndex: 10,
                    }}
                    id='bounceIcons'
                    src={giftBtn}
                    alt='gift'
                    onClick={() => {
                        playSurpriseVideo();
                        setPrize(false);
                        sleep(2000).then(() => {setDisplayStep1(true);});
                    }}
                />
            )}
            {(prize || displayShare) && (
                <audio autoPlay>
                    <source src={presentSound}></source>
                </audio>
            )}             
            {!displayDecorate && <div className='transparentArea'></div>}
            <div className='decorateArea' style={{zIndex : change ? 1 : 0}}>
                {change && <div className="text">Drag and drop your item</div>}
                <img
                    className='confirmDecorate'
                    style={{opacity : change ? 1 : 0, pointerEvents : change ? "auto" : "none"}}
                    src={greenCheck}
                    alt='confirm button'
                    onClick={()=>{greenCheckSound.play(); setChange(false); setUpdate(!update)}}
                />
                {boughts.map((bought, index) => (
                    <Draggable
                        key={index}
                        disabled={!displayDecorate}
                        bounds='parent'
                        position={{
                        x: bought.position.x * clientWidth,
                        y: bought.position.y * clientHeight,
                        }}
                        onStart={()=>{setChange(true);}}
                        onStop={(e, data) => {
                            onStop(bought, data);
                        }}
                    >
                    {bought.url.includes("https:") ?
                        <div className={`item ${bought.name}`}>
                            <img alt='reward' draggable="false" src={bought.url}/>
                        </div>
                        :
                        <div className={`item level4-${bought.name}`}>
                            <img alt='reward' draggable="false" src={generateImageUrl(bought.url)}/>
                        </div>
                    }
                  </Draggable>
                ))}
            </div>
        </div>}
        </>
    );
};
export default Level4;

